//#region import
import axios from "axios";
import { debounce, isEqual } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Overlay, Row, Tooltip } from "react-bootstrap";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import * as SpriteSpin from "spritespin";
import { getSceneViewBackgroundInfoPublic } from "../api/configuratorApiV2";
import { ConfiguratorThemesSidebar } from "../components/Configurator/ConfiguratorThemes/ConfiguratorThemesSidebar";
import { getSceneLabelOptionsV2 } from "../components/Configurator/utils";
import { API_ROOT_URL } from "../constants/apiConstant";
import {
  LOADING_DELAY,
  MAX_CAMERA_ANGLES,
  MIN_IMAGE_WIDTH_HEIGHT,
  PROTOTYPE_MESSAGES,
} from "../constants/productConfiguratorConstants";
import {
  generateAr,
  getLocalStorage,
  objectToFormData,
  setLocalStorage,
} from "../helpers/jsHelper";
import { errorToastV2 } from "../helpers/toastHelper";
import { usePageTitle } from "../hooks/usePageTitle";
import { useSendCurrentImage } from "../hooks/useSendCurrentImage";
import DownloadIcon from "../icons/DownloadIcon";
import ScreenShotIcon from "../icons/ScreenShotIcon";
import { ReactComponent as RightIcon } from "../assets/images/NextIcon.svg";
import { ReactComponent as LeftIcon } from "../assets/images/PrevIcon.svg";
import { ReactComponent as Visibility } from "../assets/images/Visibility.svg";
import { ReactComponent as VisibilityOff } from "../assets/images/VisibilityOff.svg";
import { ReactComponent as Close } from "../assets/images/close.svg";
import { ReactComponent as FullScreenIcon } from "../assets/images/fullScreen.svg";
import "./ImageViewer.scss";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import {
  REGULAR_SIZE,
  WIDE_SIZE,
  imageHubSpotPosition1,
  redirectURL1,
} from "../helpers/configuratorInfo1";
import {
  imageHubSpotPosition2,
} from "../helpers/configuratorInfo2";
import { HOTSPOT_TOOLTIP_KEY, VIEW_TOOLTIP_KEY } from "../constants/constant";
import { BigButton } from "../common";
import jsPDF from "jspdf";
import { AnimatedLoader } from "../components/Loader/AnimatedLoader";
import { useProgressiveImage } from "../hooks/useProgressiveLoading";
import { allFinishes, allFinishesCustom, allLabelsCustom } from "../utils/materials";
import ArIcon from "../icons/ArIcon";
import CurrentContext from "../utils/CurrentContext";
import useIsMobile from "../utils/useIsMobile";
import MeasureIcon from "../icons/MeasureIcon";
import { use } from "react";
import AutoRotateIcon from "../icons/AutoRotateIcon";
import { AssistantBold } from "../fonts/Assistant-Bold";
import { AssistantNormal } from "../fonts/Assistant-Regular";
import { AssistantSemibold } from "../fonts/Assistant-Semibold";
import { GFSDidotRegular } from "../fonts/GFSDidot-Regular";
import { newWoods, NO_CUSHION_UUID, Wood_Knobs, WOOD_TOP_UUID, WOODS_TO_APPEND_LAYOUT } from "../helpers/configData";

let APIData = [];
let isMounted = false , uniqueIdData = false , zoomPayload = null , hasNotifiedConfiguratorLoaded = false;
var isOpen = false;

const ImageViewer = ({
  scenes,
  isImageViewer = true,
  selectedStoreLocal,
  allStoreList,
  modelId,
  isRender,
  localLayoutData,
  localImageData,
  localProfileData,
  localSceneData,
  measureToolImages = [],
  showArButton,
  showMeasureTool,
  uuid,
}) => {
  const { modelId:urlId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [allImages, setAllImages] = useState([]);
  const [label, setLabel] = useState([]);
  const [showDetails, setShowDetails] = useState(null);
  const [currentFrame, setCurrentFrame] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showDownloadBtn, setShowDownloadBtn] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const [zoom, setZoom] = useState(false);
  const [singleMergeData, setSingleMergeData] = useState({});
  const handle = useFullScreenHandle();
  const [selectedTextureMergeId, setSelectedTextureMergeId] = useState(null);
  const [selectedTextures, setSelectedTextures] = useState([]);
  const [highResImageWidth, setHighResImageWidth] = useState(1);
  const [highResImageHeight, setHighResImageHeight] = useState(1);
  const [threeSixtyImages, setThreeSixtyImages] = useState([]);
  const [outerLoader, setOuterLoader] = useState(true);
  const [selectedStore, setSelectedStore] = useState();
  const [selectedScene, setSelectedScene] = useState({});
  const [filteredStoreList, setFilteredStoreList] = useState([]);
  const [isFinalise, setIsFinalise] = useState(false);
  const [imageDimensions, setImageDimensions] = useState(null);
  const outerContainerRef = useRef(null);
  const imageViewerRef = useRef(null);
  const carouselCardRef = useRef(null);
  const spriteSpinRef = useRef(null);
  const zoomImageRef = useRef(null);
  const [imageNaturalDimensions, setImageNaturalDimensions] = useState(null);
  const [selectedPreview, setSelectedPreview] = useState(null);
  const [allScenes, setAllScenes] = useState(scenes);
  const [zoomHoverStyle, setZoomHoverStyle] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [zoomedImage, setZoomedImage] = useState(null);
  const isMobile = window.innerWidth < 768;
  const [selectedLayoutData, setSelectedLayoutData] = useState();
  const [selectedProfileData, setSelectedProfileData] = useState();
  const [allImagesCopy, setAllImagesCopy] = useState();
  const [minMaxImgObject, setMinMaxImgObject] = useState();
  const [layoutData, setLayoutData] = useState([]);
  const [selectedFinishType, setSelectedFinishType] = useState({});
  const [sceneBackgroundInfoData, setSceneBackgroundInfoData] = useState([]);
  const [isDragging360, setIsDragging360] = useState(false);
  const [dragStart360, setDragStart360] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(true);
  const [showTooltips, setShowTooltips] = useState({
    viewTooltip: false,
    hotspotTooltip: false,
  });
  const [hobSpotLabel, setHobSpotLabel] = useState([]);
  const [selectedHubSpot, setSelectedHubSpot] = useState(null);
  const [hubSpotImagePosition, setHubSpotImagePosition] = useState([]);
  const [singleMergeLoader, setSingleMergeLoader] = useState(false);
  const hutSpotTooltipTarget = useRef(null);
  const viewTooltipTarget = useRef(null);
  const reverse =
    searchParams.get("reverse") === "true" ||
    searchParams.get("reverse") === true;
  const [iframeMessage, setIframeMessage] = useState("");
  const [loadingMessage, setLoadingMessage] = useState("");
  const [totalViews, setTotalViews] = useState(0);
  // All scene views (360 + static cam views) and their merged images, keyed by
  // view id. selectedViewId tracks which view is shown in the main area.
  const [viewsList, setViewsList] = useState([]);
  const [viewImagesMap, setViewImagesMap] = useState({});
  // Per-view merge unique_id, so the zoom (single-merge v2) payload uses the
  // selected view's own data instead of a globally-shared/raced value.
  const [viewUniqueIdMap, setViewUniqueIdMap] = useState({});
  const [selectedViewId, setSelectedViewId] = useState(null);
  const [isStaticView, setIsStaticView] = useState(false);
  // Mirror isStaticView in a ref so the SpriteSpin onFrame callback (a stale
  // closure created while a 360 was active) can tell it's now on a static view
  // and stop overwriting currentFrame with a 360 frame index.
  const isStaticViewRef = useRef(false);
  const [progressiveLoading, setProgressiveImageLoading] = useState(false);
  const loadedLowResImage = useProgressiveImage({
    src: allImages?.[currentFrame]?.jpg_image_low || allImages?.[currentFrame]?.jpg_image,
    loading: setProgressiveImageLoading,
  });
  // const [showThumbnail, setShowThumbnail] = useState(false);
  const [measureTool, setMeasureTool] = useState(false);
  const [measureImageList, setMeasureImageList] = useState(false);
  // for Ar 
  const [apiLoading, setApiLoading] = useState(false);
  const [url, setUrl] = useState(null);
  const [autoPlay360, setAutoPlay360] = useState(false);
  const [defaultFlag, setDefaultFlag] = useState(false);
  const [woodTopPaintedFlag, setWoodTopPaintedFlag] = useState(true);
  const {
    isAR,
    setIsAR,
    setIsARReady,
    isARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    setLoading,
    setArSrc,
  } = useContext(CurrentContext);

  const isMobileAr = useIsMobile();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hideSidebar = queryParams.get("hideSidebar");
  const showSidebar = queryParams.get("showSidebar");
  const showViewAngles = queryParams.get("angles");

  const hideSwatch = queryParams.get("hideSwatch");
  
  useSendCurrentImage(allImages, { frameIndex: 12 });

  const defaultShopifyFinish = [
    queryParams.get("uph") && { Upholstery: finishToSet(queryParams.get("uph")) },
    queryParams.get("lf") && { Wood: finishToSet(queryParams.get("lf")) },
    queryParams.get("lfpc") && { Wood: finishToSet(queryParams.get("lfpc")) }
  ].filter(Boolean);
  // console.log(defaultShopifyFinish,"defaultShopifyFinish");

  useEffect(() => {
    if(selectedLayoutData?.name && measureToolImages?.length){
      let listData = measureToolImages;
      listData = measureToolImages.filter(({size})=> selectedLayoutData?.name === size);
      // console.log(selectedLayoutData?.name,measureToolImages,listData);
      // if(selectedLayoutData?.name === REGULAR_SIZE){
      //   listData = measureToolImages.filter(({size})=> selectedLayoutData?.name === REGULAR_SIZE && size === "small")
      // }
      // if(selectedLayoutData?.name === WIDE_SIZE){
      //   listData = measureToolImages.filter(({size})=> selectedLayoutData?.name === WIDE_SIZE && size === "large")
      // }
      setMeasureImageList(listData)
    }
  }, [selectedLayoutData, measureToolImages]);

  useEffect(() => {
    isMounted = true;
  }, []);

  // Notify parent window once, when the initial loader AND the image itself are
  // fully done: outerLoader/imageDimensions gate the big overlay, but isLoading /
  // progressiveLoading gate the inline spinner shown while the real image swaps in.
  useEffect(() => {
    if (
      hasNotifiedConfiguratorLoaded ||
      outerLoader ||
      !imageDimensions ||
      isLoading ||
      progressiveLoading ||
      !sceneBackgroundInfoData?.length ||
      !label?.length
    ) {
      return;
    }
    hasNotifiedConfiguratorLoaded = true;
    window.parent.postMessage({ type: "CONFIGURATOR_LOADED" }, "*");
    console.log("CONFIGURATOR_LOADED_______________iframe");
  }, [outerLoader, imageDimensions, isLoading, progressiveLoading, sceneBackgroundInfoData, label]);

  // TEST ONLY: read parent website's URL / query params from inside the iframe.
  // useEffect(() => {
  //   // Works cross-origin: browser always exposes the referring page's full URL.
  //   const parentUrl = document.referrer;
  //   let parentQueryParams = {};
  //   try {
  //     parentQueryParams = Object.fromEntries(new URL(parentUrl).searchParams.entries());
  //   } catch (e) {
  //     // referrer missing/unparseable
  //   }

  //   // Chrome/Edge only: array of ancestor origins (no path/query), outermost last.
  //   const ancestorOrigins = window.location.ancestorOrigins
  //     ? Array.from(window.location.ancestorOrigins)
  //     : null;

  //   // This iframe's own URL/query (always accessible, not the parent's).
  //   const ownUrl = window.location.href;
  //   const ownQueryParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());

  //   // Direct access to parent/top location — throws if cross-origin, works if same-origin.
  //   let topUrlIfSameOrigin = null;
  //   try {
  //     topUrlIfSameOrigin = window.top.location.href;
  //   } catch (e) {
  //     topUrlIfSameOrigin = `blocked (cross-origin): ${e.message}`;
  //   }

  //   console.log("[iframe-test] document.referrer (parent URL):", parentUrl);
  //   console.log("[iframe-test] parsed parent query params:", parentQueryParams);
  //   console.log("[iframe-test] window.location.ancestorOrigins:", ancestorOrigins);
  //   console.log("[iframe-test] window.top.location.href:", topUrlIfSameOrigin);
  //   console.log("[iframe-test] own iframe URL:", ownUrl);
  //   console.log("[iframe-test] own iframe query params:", ownQueryParams);
  // }, []);

  useEffect(() => {
    setAllScenes(scenes);
  }, [scenes]);

  useEffect(() => {
    // Handler function for the message event
    const handleMessage = (event) => {
      // console.log(event.data, "event");
      if (event.data !== iframeMessage) {
        setIframeMessage(event.data);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeMessage]);

  useEffect(() => {
    if (selectedLayoutData) {
      const dataPosition = +urlId === 1 ? imageHubSpotPosition1 :  imageHubSpotPosition2 
      setHubSpotImagePosition(dataPosition[selectedLayoutData?.name]);
    }
  }, [selectedLayoutData]);

  useEffect(() => {
    if (hobSpotLabel?.length) {
      if (
        !selectedHubSpot ||
        selectedHubSpot === "layout" ||
        !hobSpotLabel?.some((labelName) => labelName === selectedHubSpot)
      ) {
        setSelectedHubSpot(localProfileData?.length > 1 ?  "profile" : hobSpotLabel[0] ||  "profile");
      }
    }
  }, [hobSpotLabel, selectedLayoutData]);

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        handleShowInfoTooltip();
      }, 2000);
    }
  }, [isLoading, visible, fullScreen, allImages]);

  const handleShowInfoTooltip = () => {
    const viewTooltipValue = getLocalStorage(VIEW_TOOLTIP_KEY);
    const hotspotTooltipValue = getLocalStorage(HOTSPOT_TOOLTIP_KEY);
    setShowTooltips({
      ...showTooltips,
      viewTooltip:
        viewTooltipValue === false || viewTooltipValue === "false"
          ? false
          : true,
      hotspotTooltip:
        hotspotTooltipValue === false || hotspotTooltipValue === "false"
          ? false
          : true,
    });
  };

  const matchesLayoutName = (item, value) =>
    item?.name_shopify ? item.name_shopify === value : item?.name === value;

  useEffect(() => {
    if (!iframeMessage.type || !iframeMessage.value) {
      return; // Exit early if there's no key or value
    }
    console.log(iframeMessage.type,iframeMessage.value,"typeeee");
    switch (iframeMessage.type) {
      // case "layout":
      //   setSelectedLayoutData(
      //     localLayoutData.find((item) => item.name === iframeMessage.value)
      //   );
      //   setZoom(false);
      //   break;
      case "Movement":
        setSelectedLayoutData(
          localLayoutData.find((item) => matchesLayoutName(item, iframeMessage?.value))
        );
        setZoom(false);
        setMeasureTool(false);
        break;
      case "Knob":  
      case "Size":
        setSelectedLayoutData(
          localLayoutData.find((item) => matchesLayoutName(item, iframeMessage?.value))
        );
        setZoom(false);
        setMeasureTool(false);
        break;
      case "Hardware Style":
        setSelectedLayoutData(
          localLayoutData.find((item) => matchesLayoutName(item, iframeMessage?.value))
        );
        setZoom(false);
        setMeasureTool(false);
        break;
      case "Variation":
        setSelectedLayoutData(
          localLayoutData.find((item) => matchesLayoutName(item, iframeMessage?.value))
        );
        setZoom(false);
        setMeasureTool(false);
        break;
      case "camera": {
        const targetView = viewsList.find(
          (view) =>
            view?.name?.toLowerCase()?.trim() ===
            iframeMessage?.value?.toLowerCase()?.trim()
        );
        if (targetView) {
          selectView(targetView);
        }
        break;
      }
      default:
        break;
    }
  }, [iframeMessage]);

  // function finishToSet(id) {
  //     return allFinishesCustom.find((item) => item.id == id).value;
  // }
  function finishToSet(id) {

    // return id;

    if (typeof id === "number") {
      return allFinishesCustom.find((item) => item.id === id)?.value;
    } else if (typeof id === "string") {
      const return_value = allFinishesCustom.find((item) => item.id === id)?.value;
      return (return_value ? return_value : id);
    } 
    
  }

  function labelToSet(label) {
      return allLabelsCustom.find((item) => item.id === label)?.value;
  }

  const handleCushionOrFrameMessage = (message) => {
    if (!message?.type || !message?.value) {
      return; // Exit early if there's no key or value
    }
    console.log(message.value,message.type,"valuessss")
    setZoom(false)
    if(message.type === 'Cushion'){
      if (message.value === 'No Cushion') {
        setSelectedLayoutData(
          localLayoutData.find(({name})=> name === "No Cushion")
        );
        return; // Exit early if there's no key or value
        // 140 means no cushion scene activate
      }else{
         setSelectedLayoutData(
            localLayoutData.filter(({name})=> name !== "No Cushion")?.[0]
          );
          console.log("iframeMessage____________________1",message);
          console.log("iframeMessage.type",labelToSet(message.type));
          console.log("iframeMessage.value",finishToSet(message.value));
          const foundLabel = label.find((item) => item.name === labelToSet(message.type));
          if (!foundLabel) {
            console.log("label",label);
            setSelectedFinishType?.({
              ...selectedFinishType,
              [labelToSet(message.type)]: {display_name:finishToSet(message.value).trim()},
            })
            // console.log('No matching label found for key:', message.key);
            return; // Exit if the label doesn't match
          }

          const foundTexture = foundLabel.textures.find(
            (texture) => texture.display_name.trim() === finishToSet(message.value).trim()
          );
          if (!foundTexture) {
            // console.log('No matching texture found for value:', message.value);
            return; // Exit if no texture is found
          }

          // console.log("Matching texture:", foundTexture);

          // Extract labelId and textureId once to use in the getDefaultTextures call
          const { id: labelId } = foundLabel;
          const textureId = foundTexture;
          if(foundTexture && foundTexture){
           setSelectedFinishType?.({
            ...selectedFinishType,
            [foundLabel?.name]: foundTexture,
          })
          }
          // Call getDefaultTextures with the appropriate parameters
          getDefaultTextures({
            labelId,
            textureId,
            isDisabled: message.isDisabled,
          });
        //  console.log("Selected RRR", localLayoutData.filter(({name})=> name !== "No Cushion")?.[0]);
      }
    }else if(message.type === 'Paint Color' || message.type === 'Chair Frame'){
        console.log(uuid,"uuid");

          // const foundLabel = label.find((item) => item.name === 'Wood Finish');
          // const foundLabel = label.find(
          //   // (item) => item.name === ((uuid === '129' || uuid === '174') ? 'Paint Finish' : 'Wood Finish')
          //   (item) =>
          //     item.name === (
          //       uuid === '129' || uuid === '174'
          //         ? 'Paint Color'
          //         : uuid === '115' || uuid === '117' || uuid === '136'
          //         ? 'Paint Color'
          //         : 'Wood Finish'
          //     )
          // );

          const isPaintColor = ['129', '174', '115', '117'].includes(uuid);
          const foundLabel = label.find(
            (item) => item.name === (isPaintColor ? 'Paint Color' : 'Wood Finish')
          );


          if (!foundLabel) {
            console.log("label",label);
            console.log('No matching label found for key:', message.type);
            return; // Exit if the label doesn't match
          }
          const foundTexture = foundLabel.textures.find(
            (texture) => texture.display_name.trim() === finishToSet(message.value).trim()
          );
          if (!foundTexture) {
            // console.log('No matching texture found for value:', message.value);
            return; // Exit if no texture is found
          }

          // console.log("Matching texture:", foundTexture);

          // Extract labelId and textureId once to use in the getDefaultTextures call
          const { id: labelId } = foundLabel;
          const textureId = foundTexture;
          if(foundTexture && foundTexture){
           setSelectedFinishType?.({
            ...selectedFinishType,
            [foundLabel?.name]: foundTexture,
          })
          }
          // Call getDefaultTextures with the appropriate parameters
          getDefaultTextures({
            labelId,
            textureId,
            isDisabled: message.isDisabled,
          });
        //  console.log("Selected RRR", localLayoutData.filter(({name})=> name !== "No Cushion")?.[0]);

    }
  };

  const handleGeneralIframeMessage = (message) => {
    if (!message?.type || !message?.value) {
      return; // Exit early if there's no key or value
    }
    console.log(message.value,message.type,"valuessss")

    if (!['Leg Finish','Wood Finish','Hardware Style', 'Upholstery','Leg Finish + Paint Color','Paint Color','Wood Top', 'Turned Leg Finish','Headboard Fabric','Welt','Metal Legs','Shelf Paint'].includes(message.type)) {
      return;
    }
    setZoom(false);

    // const foundLabel = label.find((item) => item.name === labelToSet(message.type));
    let foundLabel = label.find( (item) => item.name === labelToSet(message.type) );
    if (!foundLabel && message.type === 'Paint Color')
    { 
      foundLabel = label.find( (item) => item.name === labelToSet('Wood Finish') ); 
    }

    console.log("foundLabel_________",labelToSet(message.type))
    console.log("foundTexture_________",finishToSet(message.value))

    if (!foundLabel) {
      // console.log('No matching label found for key:', message.key);
      return; // Exit if the label doesn't match
    }
    const foundTexture = foundLabel.textures.find(
      (texture) => texture.display_name.trim() === finishToSet(message.value).trim()
    );
    if (!foundTexture) {
      // console.log('No matching texture found for value:', message.value);
      return; // Exit if no texture is found
    }

    console.log("Matching texture:", foundTexture);

    // Extract labelId and textureId once to use in the getDefaultTextures call
    const { id: labelId } = foundLabel;
    const textureId = foundTexture;
    if(foundTexture && foundTexture){
     setSelectedFinishType?.({
      ...selectedFinishType,
      [foundLabel?.name]: foundTexture,
    })
    }
    // Call getDefaultTextures with the appropriate parameters
    getDefaultTextures({
      labelId,
      textureId,
      isDisabled: message.isDisabled,
    });
  };

  const handleWoodKnobIfrmaeMessage = (message) => {
    if (!message?.type || !message?.value) {
      return; // Exit early if there's no key or value
    }
    console.log(message.value,message.type,"valuessss")
    setZoom(false)
    if(message.type === 'Hardware Style'){
      if (message.value === 'Wood Knobs') {
        // console.log("Wood Knobs Selected")
        setSelectedLayoutData(
          localLayoutData.find(({name})=> name === "Wood Knobs")
        );
        return; // Exit early if there's no key or value
        // 140 means no cushion scene activate
      }else{
        console.log("Wood Knobs not Selected")
         setSelectedLayoutData(
            localLayoutData.filter(({name})=> name !== "Wood Knobs")?.[0]
          );
          const foundLabel = label.find((item) => item.name === labelToSet(message.type));
          if (!foundLabel) {
            setSelectedFinishType?.({
              ...selectedFinishType,
              [labelToSet(message.type)]: {display_name:finishToSet(message.value).trim()},
            })
            // console.log('No matching label found for key:', message.key);
            return; // Exit if the label doesn't match
          }
          const foundTexture = foundLabel.textures.find(
            (texture) => texture.display_name.trim() === finishToSet(message.value).trim()
          );
          if (!foundTexture) {
            // console.log('No matching texture found for value:', message.value);
            return; // Exit if no texture is found
          }

          // console.log("Matching texture:", foundTexture);

          // Extract labelId and textureId once to use in the getDefaultTextures call
          const { id: labelId } = foundLabel;
          const textureId = foundTexture;
          if(foundTexture && foundTexture){
           setSelectedFinishType?.({
            ...selectedFinishType,
            [foundLabel?.name]: foundTexture,
          })
          }
          // Call getDefaultTextures with the appropriate parameters
          getDefaultTextures({
            labelId,
            textureId,
            isDisabled: message.isDisabled,
          });
        //  console.log("Selected RRR", localLayoutData.filter(({name})=> name !== "No Cushion")?.[0]);
      }
    }
    else if(message.type === 'Paint Color' || message.type === 'Wood Finish')
    {
        console.log(uuid,"uuid");

        console.log("iframeMessage____________________1",message);
        console.log("iframeMessage.type",labelToSet(message.type));
        console.log("iframeMessage.value",finishToSet(message.value));

          const foundLabel = label.find((item) => item.name === labelToSet(message.type));
          if (!foundLabel) {
            // console.log('No matching label found for key:', message.key);
            return; // Exit if the label doesn't match
          }
          const foundTexture = foundLabel.textures.find(
            (texture) => texture.display_name.trim() === finishToSet(message.value).trim()
          );
          if (!foundTexture) {
            // console.log('No matching texture found for value:', message.value);
            return; // Exit if no texture is found
          }

          // console.log("Matching texture:", foundTexture);

          // Extract labelId and textureId once to use in the getDefaultTextures call
          const { id: labelId } = foundLabel;
          const textureId = foundTexture;
          if(foundTexture && foundTexture){
           setSelectedFinishType?.({
            ...selectedFinishType,
            [foundLabel?.name]: foundTexture,
          })
          }
          // Call getDefaultTextures with the appropriate parameters
          getDefaultTextures({
            labelId,
            textureId,
            isDisabled: message.isDisabled,
          });
        //  console.log("Selected RRR", localLayoutData.filter(({name})=> name !== "No Cushion")?.[0]);

    }
  };

  // console.log(modelId,scenes,label,"allLabelsallLabels")
      // console.log(label,totalViews,"label");
//  console.log(selectedStore,"selectedStore")
  useEffect(() => {
    runEffect()
  }, [iframeMessage]);

  const runEffect = async () => {
    if (iframeMessage.type) {
      console.log("inside run effect________1");
      console.log("iframeMessage",iframeMessage);
    }
    if(WOOD_TOP_UUID.includes(uuid)){
      if (!iframeMessage.type) {
        return; // Exit early if there's no key or value
      }
      setZoom(false);
      console.log(iframeMessage,"iframeMessage");
      let selectedStoreToPass = null;
      if (allStoreList?.length) {
        for (let i = 0; i < allStoreList.length; i++) {
          if (allStoreList[i].scene === selectedScene.id) {
            selectedStoreToPass = allStoreList[i];
            break;
          }
        }
      }

      const labelData = await Promise.all([
        selectedStoreToPass?.labels?.length
          ? Promise.resolve(selectedStoreToPass.labels)
          : getSceneLabelOptionsV2({
              sceneId: selectedStoreToPass?.scene,
              token: modelId,
              storeId: selectedStoreToPass?.id,
            }),
      ]);
      const foundTextures = [];

      const messageKeys = Object.keys(iframeMessage).filter(key => key !== 'type');
      let selectedOptionFinishData = {...selectedFinishType}
      let optionLabel = []
      messageKeys.forEach(key => {
        let valueToMatch = iframeMessage[key];
        if (key === "Wood Top" && valueToMatch === "Painted") {
          valueToMatch = iframeMessage["Paint Color"];
        }

        const matchedLabel = (labelData?.[0] || label).find(item => item.name === key);

        if (matchedLabel) {
          const matchedTexture = matchedLabel.textures.find(
            texture => texture.display_name === valueToMatch
          );
          optionLabel.push({...matchedLabel , 'selectedTexture': matchedTexture})
          if (matchedTexture) {
            foundTextures.push(matchedTexture);
            selectedOptionFinishData[matchedLabel?.name] = matchedTexture
          }
        }
      });

      setSelectedFinishType?.({
        ...selectedFinishType,
        ...selectedOptionFinishData
      })
      const textures = foundTextures?.map((val) => val?.id);
      const renders = foundTextures?.map((val) => val?.render_id);
      const sceneTextureRender = foundTextures?.map((val) => val?.scenetexturerender_id);
      const data = {
        textures: textures,
        renders: renders,
        scenetexture_render: sceneTextureRender,
        is_render: true,
        scene_view: sceneBackgroundInfoData?.[0]?.id,
        scene: selectedScene?.id,
        store: selectedStoreToPass?.id || selectedStore?.id,
        ext: "png",
      };

      // console.log(data,foundTextures, "datadatadatadata");
      if(data?.textures?.length || data?.renders?.length || data?.scenetexture_render?.length){
       setLabel(optionLabel)
       getAllMergeDataMultiLabel(data);
      }
    }else if(NO_CUSHION_UUID.includes(uuid)){
      // Parent may send a single {type,value} message (normal case) or an
      // array of them in one postMessage call (e.g. batched at load time).
      const messages = Array.isArray(iframeMessage) ? iframeMessage : [iframeMessage];
      messages.forEach((message) => handleCushionOrFrameMessage(message));
    }else if(Wood_Knobs.includes(uuid)){
      // Parent may send a single {type,value} message (normal case) or an
      // array of them in one postMessage call (e.g. batched at load time).
      const messages = Array.isArray(iframeMessage) ? iframeMessage : [iframeMessage];
      messages.forEach((message) => handleWoodKnobIfrmaeMessage(message));
    }else{
      // Parent may send a single {type,value} message (normal case) or an
      // array of them in one postMessage call (e.g. batched at load time).
      const messages = Array.isArray(iframeMessage) ? iframeMessage : [iframeMessage];
      messages.forEach((message) => handleGeneralIframeMessage(message));
    }
  }

  const startDrag360 = (x, y) => {
    setIsDragging360(true);
    setDragStart360({
      x: x - zoomHoverStyle.x,
      y: y - zoomHoverStyle.y,
    });
  };

  const handleDrag360 = (x, y) => {
    if (isDragging360) {
      setZoomHoverStyle({
        x: x - dragStart360.x,
        y: y - dragStart360.y,
      });
    }
  };

  const stopDrag360 = () => {
    setIsDragging360(false);
  };


  function removeDuplicateImage(list) {
    const uniqueSeqNos = {};
    const uniqueArray = [];
    list?.forEach((item) => {
      if (!uniqueSeqNos[item?.seq_no]) {
        uniqueSeqNos[item?.seq_no] = true;
        uniqueArray.push(item);
      }
    });
    return uniqueArray;
  }
  

  function handleFilterAllImage() {

    let filterAllImage = removeDuplicateImage(allImages) || [];
    return filterAllImage;
  }

  // Switch the main viewer to the given view. 360 views (config_type "2")
  // rebuild the SpriteSpin; static views (config_type "1") render a single image.
  const selectView = (view) => {
    if (
      !view ||
      parseInt(view.id) === parseInt(selectedViewId) ||
      isLoading ||
      outerLoader
    )
      return;
    const imgs = viewImagesMap[view.id] || [];
    if (!imgs.length) return;
    setZoom(false); // exit zoom when switching views (else the new view stays hidden)
    setSelectedViewId(view.id);
    if (view?.config_type === "2") {
      setIsStaticView(false);
      APIData = [...imgs];
      setAllImages(imgs);
      setAllImagesCopy(imgs);
      const lowResList = imgs.map(
        (im) => im?.jpg_image_low || im?.image_low
      );
      setThreeSixtyImages(lowResList); // re-inits SpriteSpin via effect
      setCurrentFrame(view?.loading_angle || 0);
    } else {
      setIsStaticView(true);
      setMeasureTool(false); // measure tool is only for the 360 view
      setAllImages(imgs);
      setCurrentFrame(0);
    }
  };
  //#endregion

  usePageTitle("MaineCottage");

  useEffect(() => {
    if (localLayoutData?.length && localProfileData?.length) {
      if (
        !localLayoutData?.some(({ name }) => name === selectedLayoutData?.name)
      ) {
        setSelectedLayoutData(localLayoutData[0]);
      }
      setLayoutData(localLayoutData);
    }
  }, [selectedProfileData]);

  useEffect(() => {
    if (
      selectedLayoutData?.id &&
      selectedProfileData?.id &&
      localSceneData?.length
    ) {
      let locScene = null;
      if (!locScene) {
        locScene = localSceneData.find(
          (ld) =>
            ld.layoutId === selectedLayoutData?.id &&
            ld.profileId === selectedProfileData?.id
        );
        // localSceneData.find(
        //   (ld) =>
        //     +ld.layoutId === +selectedLayoutData?.id &&
        //     +ld.profileId === +selectedProfileData?.id &&
        //     +ld.doorId === +selectedDoorStyle?.id,
        // ) ||
      }
      let sceneToSelect;
      for (let i = 0; i < allStoreList.length; i++) {
        if (allStoreList[i].scene === locScene?.id) {
          sceneToSelect = allStoreList[i].scene;
          break;
        }
      }
      const scene = allScenes.find(
        (scene) => parseInt(scene?.id) === parseInt(sceneToSelect)
      );
      setSelectedScene(scene);
    }
  }, [selectedLayoutData, selectedProfileData, selectedStore]);

  const sceneBackgroundInfo = async (payload) => {
    const res = await getSceneViewBackgroundInfoPublic(payload);
    setSceneBackgroundInfoData(res);
    return res;
  };

  useEffect(() => {
    if (localLayoutData?.length && localProfileData?.length) {
      setSelectedLayoutData(localLayoutData[0]);
      setSelectedProfileData(localProfileData[0]);
    }
  }, [localLayoutData, localProfileData]);

  useEffect(() => {
    if (
      outerLoader ||
      !selectedStore ||
      !handleFilterAllImage()?.length ||
      !outerContainerRef ||
      !imageViewerRef ||
      (isImageViewer && !carouselCardRef)
    ) {
      return;
    }
    const throttledRecalculateSize = debounce(calculateImageSize, 70);
    throttledRecalculateSize();
    window.addEventListener("resize", throttledRecalculateSize);
    window.addEventListener("mouseup", () => setIsDragging(false));
    return () => {
      window.removeEventListener("resize", throttledRecalculateSize);
      window.removeEventListener("mouseup", () => setIsDragging(false));
    };
  }, [
    outerLoader,
    fullScreen,
    selectedStore,
    allImages,
    isImageViewer,
    outerContainerRef,
    carouselCardRef,
    imageViewerRef,
    isFinalise,
  ]);

  useEffect(() => {
    if (allStoreList?.length) {
      // !isMounted && setOuterLoader(true);
      !isMounted ? setOuterLoader(true) : showLoader();
      // const scenes = await getScenesInPrototypeForPublic({
      //   token: modelId,
      //   is_render: isRender,
      // });
      // setAllScenes([...scenes]);
      if (allScenes?.length) {
        const sceneId = allScenes[0]?.id;
        let filteredData = allStoreList?.filter(
          (val) => parseInt(val?.scene) === parseInt(sceneId)
        );
        if (!filteredData?.length && selectedStoreLocal) {
          filteredData = [selectedStoreLocal];
        }
        const sortedData = filteredData.sort(
          (a, b) => new Date(b?.updated_at) - new Date(a?.updated_at)
        );
        sortedData?.length && setSelectedStore(sortedData[0]);
      }
    }
  }, [allScenes, selectedStoreLocal, allStoreList]);

  useEffect(() => {
    if (outerLoader) {
      setLoadingMessage(PROTOTYPE_MESSAGES[0]);
      setTimeout(() => {
        setLoadingMessage(PROTOTYPE_MESSAGES[1]);
      }, LOADING_DELAY);
      setTimeout(() => {
        setLoadingMessage(PROTOTYPE_MESSAGES[2]);
      }, LOADING_DELAY * 2);
    }
  }, [outerLoader]);

  useEffect(() => {
    if (selectedScene?.id) {
      showLoader();
      let filteredStore;
      if (allStoreList?.length > 1) {
        filteredStore = getFilterStore(allStoreList, selectedScene);
      } else {
        filteredStore = JSON.parse(JSON.stringify(allStoreList));
      }
      setFilteredStoreList([...filteredStore]);
    }
  }, [selectedScene]);

  useEffect(() => {
    if (filteredStoreList?.length) {
      getStoreData();
    }
  }, [filteredStoreList,defaultFlag]);

  useEffect(() => {
    isStaticViewRef.current = isStaticView;
  }, [isStaticView]);

  // Share every view's thumbnail (name + image url) with the parent window once
  // the views and their merged images are ready, and again when they change.
  useEffect(() => {
    if (!viewsList?.length) return;
    const thumbnails = viewsList
      .map((view) => {
        const imgs = viewImagesMap[view?.id] || [];
        if (!imgs.length) return null;
        // 360 view -> loading-angle frame, static view -> its single image.
        const idx =
          view?.config_type === "2"
            ? Math.min(view?.loading_angle || 0, imgs.length - 1)
            : 0;
        const frame = imgs[idx] || imgs[0];
        const url = frame?.jpg_image_low || frame?.image_low || frame?.jpg_image;
        if (!url) return null;
        return { id: view?.id, name: view?.name, url };
      })
      .filter(Boolean);
    if (!thumbnails.length) return;
    // console.log({ type: "VIEW_THUMBNAILS", thumbnails },"thumbnails");
    window.parent.postMessage({ type: "VIEW_THUMBNAILS", thumbnails }, "*");
  }, [viewsList, viewImagesMap]);

  useEffect(() => {
    if (!isStaticView && imageViewerRef && spriteSpinRef && threeSixtyImages.length) {
      create360(threeSixtyImages);
    }
  }, [
    spriteSpinRef,
    imageViewerRef,
    threeSixtyImages,
    currentFrame,
    autoPlay360,
    isStaticView,
  ]);

  // Fullscreen enter/exit re-initializes the 360 once the layout has settled.
  // The browser fullscreen transition is async, so building SpriteSpin on the
  // raw `fullScreen` state change measures the wrong (pre-transition) size and
  // renders nothing. Waiting a tick lets the new container reach its final size
  // so the 360 is visible and drag/zoom work.
  useEffect(() => {
    if (isStaticView || !threeSixtyImages.length) return;
    const timer = setTimeout(() => {
      if (spriteSpinRef?.current) {
        create360(threeSixtyImages);
        window.dispatchEvent(new Event("resize"));
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [fullScreen]);

  useEffect(() => {
    async function getYourData() {
      if (zoom && !isLoading && !outerLoader) {
        await zoom360Image({ images: handleFilterAllImage() || [] });
      }
    }
    getYourData();
  }, [zoom, allImages, currentFrame, selectedTextures, isLoading, outerLoader]);

  const getMeta = (url, cb) => {
    const img = new Image();
    img.onload = () => cb(null, img);
    img.onerror = (err) => cb(err);
    img.src = url;
  };

    useEffect(() => {
    return () => {
      setApiLoading(false);
      setUrl(null);
      setLoading(false);
      setIsARReady(false);
      setIsAR(false);
      setARModelSrc(null);
      setARUnicode(null);
      isOpen = false;
    };
  }, []);

  useEffect(() => {
    if (!ARModelSrc) return;
    setUrl(ARModelSrc);
  }, [ARModelSrc]);

  // function buildTextureMap(label) {
  //   return label.reduce((acc, item) => {
  //     if (item.selectedTexture?.display_name) {
  //       acc[item.name] = item.selectedTexture.display_name;
  //     }
  //     return acc;
  //   }, {});
  // }

  function buildTextureMap(label) {
    const isNewWoodUuid =
      Array.isArray(newWoods) && newWoods.some((id) => String(id) === String(uuid));

    return label.reduce((acc, item) => {
      let displayName = item.selectedTexture?.display_name?.trim();

      if (displayName) {
        if(uuid === "143"){
          if (WOODS_TO_APPEND_LAYOUT.includes(displayName)) {
            displayName = `${displayName} ${selectedLayoutData?.name}`;
          }
        }
        const shouldAppendNew =
          isNewWoodUuid &&
          (displayName === "Natural Maple" || displayName === "Natural Cherry");

        acc[item.name] = shouldAppendNew ? `${displayName} new` : displayName;
      }

      return acc;
    }, {});
  }
  
  // console.log(modelId,scenes,selectedTextures,label,"allLabelsallLabels");

  // console.log(selectedLayoutData,"selectedLayoutDataselectedLayoutData");

  useEffect(() => {
    const textureMap = buildTextureMap(label);
    console.log(textureMap,"textureMap");
    

    if (isAR && textureMap && selectedScene) {
      generateAr({
        // token: modelId,
        sceneId: selectedScene.id,
        textureMap,
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setArSrc(file)
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR,label,selectedScene]);

  const getFilterStore = (storeList, currentScene) => {
    if (currentScene?.id) {
      return storeList.filter((store) => store.scene === currentScene.id);
    }
  };

  const calculateAspectRatioFit = (
    srcWidth,
    srcHeight,
    maxWidth,
    maxHeight
  ) => {
    const isMobile = false; // Check mobile screen size dynamically
    const useMaxRatio = isMobile && !fullScreen && !isFinalise;

    const ratio = useMaxRatio
      ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight)
      : Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    
    let width = Math.round(srcWidth * ratio);
    let height = Math.round(srcHeight * ratio);
  
    // Ensure width and height are within bounds
    width = Math.max(1, Math.min(width, maxWidth)); 
    height = Math.max(1, Math.min(height, maxHeight));
    return { width, height };
  };
  const getInnerSize = (element) => {
    const cs = getComputedStyle(element);
    const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    const paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
    const borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    const width = element.clientWidth - paddingX - borderX;
    const height = element.clientHeight - paddingY - borderY;
    return { width, height };
  };

  const calculateImageSize = () => {
    if (
      handleFilterAllImage()?.length &&
      handleFilterAllImage()[currentFrame] &&
      outerContainerRef?.current &&
      !fullScreen
    ) {
      const { width: maxAvailableWidth, height: maxAvailableHeight } =
        getInnerSize(outerContainerRef?.current);
      const callback = (img) => {
        // let heightToAdjust = maxAvailableHeight - PADDING_VALUE_VIEWER;
        let heightToAdjust = maxAvailableHeight;
        const carouselCardHeight = carouselCardRef?.current?.clientHeight;
        if (isImageViewer && carouselCardHeight) {
          heightToAdjust = heightToAdjust - carouselCardHeight;
        }
        const newImageValues = calculateAspectRatioFit(
          img.naturalWidth ? img.naturalWidth : 1000,
          img.naturalHeight ? img.naturalHeight : 1000,
          maxAvailableWidth,
          heightToAdjust
        );
        setImageNaturalDimensions({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
        if (
          imageViewerRef?.current?.style &&
          !isNaN(newImageValues.height) &&
          !isNaN(newImageValues.width)
        ) {
          imageViewerRef.current.style.height = newImageValues.height + "px";
          imageViewerRef.current.style.width = newImageValues.width + "px";
          setImageDimensions({
            height:
              !isImageViewer || !carouselCardHeight
                ? newImageValues.height
                : newImageValues.height + carouselCardHeight,
            width: newImageValues.width,
          });
        }
      };
      if (getImageConfImage(handleFilterAllImage()[currentFrame])) {
        getMeta(
          getImageConfImage(handleFilterAllImage()[currentFrame]),
          (err, img) => {
            callback(img);
          }
        );
      } else {
        callback({
          naturalWidth: MIN_IMAGE_WIDTH_HEIGHT,
          naturalHeight: MIN_IMAGE_WIDTH_HEIGHT,
        });
      }
    }
  };

  const getStoreData = () => {
    try {
      if (allStoreList?.length) {
        let selectedStoreToPass;
        for (let i = 0; i < allStoreList.length; i++) {
          if (allStoreList[i].scene === selectedScene.id) {
            selectedStoreToPass = allStoreList[i];
            break;
          }
        }
        initializeData(selectedStoreToPass);
      }
    } catch (err) {
      errorToastV2("Something went wrong. Please try again.");
    }
  };

  const initializeData = async (data) => {
    const allData = data;
    if (!allData) return;
    let areDefaultImagesPresent = false;
    const configuratorData = allData.configurator;
    const showDownloadBtn = configuratorData.is_download_enabled;
    const highResImageWidth = selectedScene?.render_reso_x;
    const highResImageHeight = selectedScene?.render_reso_y;
    const defaultTextures = [];
    APIData = [];
    if(data?.loading_angle){
      setCurrentFrame(data?.loading_angle || 0)
    }
    if (allData?.default_merge?.images?.length && !selectedTextures?.length) {
      areDefaultImagesPresent = true;
      APIData = [...APIData, ...allData?.default_merge?.images];
      setAllImages(allData?.default_merge?.images);
      const images = [];
      allData?.default_merge?.images.forEach((image) => {
        images.push(image?.jpg_image_low || image.image_low);
      });
      setThreeSixtyImages(images);
      setAllImagesCopy(allData?.default_merge?.images);
      setOuterLoader(false);
    }
    // if(!selectedTextures?.length){
    //   // setShowThumbnail({id:allData?.default_merge?.textures?.[0]})
    //   setShowThumbnail({id:148817}) // default dove swatch
    // }
    const [sceneBackround, labelOptions] = await Promise.all([
      sceneBackgroundInfo({
        storeId: allData?.id,
        token: modelId,
        scene: allData?.scene,
      }),
      allData?.labels?.length
        ? Promise.resolve(allData.labels) // If labels exist, use them
        : getSceneLabelOptionsV2({
            sceneId: allData?.scene,
            token: modelId,
            storeId: allData?.id,
          }),
    ]);
    // console.log(sceneBackround,"sceneBackround");
    setTotalViews(sceneBackround?.length || 0);
    let labels = labelOptions.map((element, index) => {
      // console.log(element,selectedFinishType,"elementelement");
      element["start_image"] = 0;
      element["end_image"] = MAX_CAMERA_ANGLES - 1;
      element["amount"] = element.textures.length;
      element["page_id"] = 1;
      element["show"] = index === 0;
      element["sceneId"] = allData?.scene;
      element["token"] = modelId;
      element["storeId"] = allData?.id;
      if (element.name !== "default_label") {
        element.textures.forEach((texture, idx) => {
          const textureCopy = { ...texture, active: true };
          if (idx === 0) {
            if (selectedFinishType[element.name]) {
              const data = element.textures.find(
                ({ display_name }) =>
                  display_name ===
                  selectedFinishType[element.name]?.display_name
              );
              element["selectedTexture"] = data || texture;
              defaultTextures.push({
                id: (data || texture)?.id,
                renderId: (data || texture)?.render_id,
                sceneTextureId: (data || texture)?.scenetexturerender_id,
              });
            } else {
              if(defaultShopifyFinish && defaultShopifyFinish?.length > 0){
                let textureFlag = false;
                
                defaultShopifyFinish.forEach(finish => {
                  const key = Object.keys(finish)[0];
                  //console.log(key,"key");
                  const value = finish[key];
                  //console.log(value,"value");
                  if (element.name.toLowerCase() === key.toLowerCase()) {
                    const shopifySelectedTexture = element.textures.find((item) => item?.display_name === value);
                    //console.log(shopifySelectedTexture,"shopifySelectedTexture");
                    if(shopifySelectedTexture){
                      defaultTextures.push({
                        id: shopifySelectedTexture.id,
                        renderId: shopifySelectedTexture.render_id,
                        sceneTextureId: shopifySelectedTexture.scenetexturerender_id,
                      });
                      element["selectedTexture"] = shopifySelectedTexture;
                      textureFlag = true;
                      setDefaultFlag(true);
                    }
                    //console.log(shopifySelectedTexture,element.textures,value,"valuesssssssssssssssssssss");
                  }
                });
                if(!textureFlag){
                  element["selectedTexture"] = texture;
                  defaultTextures.push({
                    id: texture.id,
                    renderId: texture.render_id,
                    sceneTextureId: texture.scenetexturerender_id,
                  });
                }
              }else{
                element["selectedTexture"] = texture;
                defaultTextures.push({
                  id: texture.id,
                  renderId: texture.render_id,
                  sceneTextureId: texture.scenetexturerender_id,
                });
              }
            }
          }
        });
      }
      return element;
    });
    labels = labels.filter((label) => label?.id);
    setLabel(labels);
    const renderIds = getRenderIdsFromTextureIds(defaultTextures);
    const mergeData = {
      scene: allData?.scene,
      textures: defaultTextures,
      is_render: true,
      ext: "png",
      store: allData?.id,
      renders: renderIds,
    };
    setSingleMergeData(mergeData);
    setSelectedTextures(defaultTextures);
    setHighResImageWidth(highResImageWidth);
    setHighResImageHeight(highResImageHeight);
    try {
      if (!outerLoader) {
        showLoader();
      }
      // console.log(sceneBackround,"sceneBackround views")
      // Merge every view (360 + static cam views). Each result is tagged with
      // its source view so we can group images per view for the thumbnails.
      const mergeResults = await Promise.all(
        sceneBackround.map(async (list) => {
          // The default 360 view's images are already loaded from default_merge,
          // so reuse them instead of re-merging.
          if (
            list?.config_type === "2" &&
            areDefaultImagesPresent &&
            allData?.default_merge?.sceneview?.[0] &&
            parseInt(allData?.default_merge?.sceneview[0]) === parseInt(list.id)
          ) {
            return { view: list, data: allData?.default_merge, fromDefault: true };
          }
          const res = await getAllMergeData({
            mergeData,
            textureIds: defaultTextures,
            sceneView: list?.id,
          });
          return res ? { view: list, data: res, fromDefault: false } : null;
        })
      );
      const validResults = mergeResults.filter(Boolean);

      // Per-view image + unique_id maps used by thumbnails, switching and zoom.
      const imagesMap = {};
      const uniqueIdMap = {};
      validResults.forEach(({ view, data }) => {
        imagesMap[view.id] = data?.images || [];
        uniqueIdMap[view.id] =
          data?.unique_id || data?.default_merge_data_copy?.unique_id || "";
      });
      setViewImagesMap(imagesMap);
      setViewUniqueIdMap(uniqueIdMap);
      setViewsList(sceneBackround);

      // Default view = the 360 view if present, otherwise the first view.
      const defaultView =
        sceneBackround.find((v) => v?.config_type === "2") || sceneBackround[0];
      setSelectedViewId(defaultView?.id);
      setIsStaticView(defaultView?.config_type !== "2");

      // Feed the main 360 viewer (skip the already-loaded default images).
      const threeSixtyData = validResults
        .filter(({ view, fromDefault }) => view?.config_type === "2" && !fromDefault)
        .map(({ data }) => data);
      uniqueIdData = validResults.find(({ view }) => view?.config_type === "2")?.data
        || allData?.default_merge
        || null;
      handleSetPayloadValue(defaultTextures,mergeData,sceneBackround)
      if (defaultView?.config_type !== "2") {
        // Default view is a static image — show it directly.
        setAllImages(imagesMap[defaultView.id] || []);
        setCurrentFrame(0);
        loadedImage();
      } else if (threeSixtyData?.length && threeSixtyData?.[0]?.images?.length) {
        updateImages({ data: threeSixtyData });
        loadedImage();
      } else {
        loadedImage();
      }
    } catch (error) {
      console.error("Error occurred while uploading image:", error);
    }
    // setShowDownloadBtn(showDownloadBtn);
    setIsFinalise(configuratorData?.is_finalize);
  };

  const handleSetPayloadValue = (defaultTextures,mergeData,sceneBackround) => {
    const allTextures = defaultTextures || selectedTextures;
    const textures = allTextures?.map((val) => val?.id);
    const renders = allTextures?.map((val) => val?.renderId);
    const sceneTextureRender = allTextures?.map((val) => val?.sceneTextureId);
    const data = {
      textures: textures,
      renders: renders,
      is_render: true,
      scenetexture_render: sceneTextureRender,
      scene_view: sceneBackround?.[0]?.id,
      scene: mergeData?.scene,
      store: mergeData?.store,
      ext: "png",
    };
    zoomPayload = data

  }

  const getRenderIdsFromTextureIds = (defaultTextures) => {
    const renderIds = [];
    const renderStatus = selectedStore?.render_status || [];
    renderStatus?.map((val) => {
      if (defaultTextures.indexOf(val.scene_texture__id) !== -1) {
        renderIds.push(val.renders__id);
      }
      return null;
    });
    return renderIds;
  };

  const create360 = (images) => {
    SpriteSpin.spritespin({
      target: spriteSpinRef?.current || {},
      height: imageDimensions?.height,
      width: imageDimensions?.width,
      source: Object.values(images),
      sourceZoom: [],
      sense: 1,
      animate: false,
      // animate: autoPlay360,
      // frameTime: 120,
      frame: currentFrame,
      zoomUseClick: true,
      zoomUseWheel: true,
      zoomPinFrame: true,
      plugins: isLoading ? ["360", "drag", "progress"] : ["360", "drag"],
      responsive: true,
      onInit: () => {
        setIsLoading(true)
        setProgressiveImageLoading(true)
      },
      onFrame: function (e, data) {
         setIsLoading(false)
         setProgressiveImageLoading(false)
        // Ignore stray frame events from a lingering 360 instance after the user
        // has switched to a static view — otherwise currentFrame would be reset
        // to a 360 index and break the static image / zoom.
        if (isStaticViewRef.current) return;
        setCurrentFrame(data.frame);
      },
      onLoad: (e) => {
        setOuterLoader(false);
        // loadedImage(e);
      },
    });
  };

  const getDefaultTextures = async ({ labelId, textureId, isDisabled }) => {
    if (isDisabled) {
      errorToastV2(
        "This texture preview is still in progress. Please try again after some time."
      );
      return;
    }
    if (isLoading || outerLoader) {
      return;
    }
    const labels = [...label];
    const defaultTextures = [...selectedTextures];
    const sceneBackround = sceneBackgroundInfoData?.length
      ? sceneBackgroundInfoData
      : await sceneBackgroundInfo({
          storeId: selectedStoreLocal?.id,
          token: modelId,
          scene: selectedScene?.id,
        });
    labels.map((val) => {
      let selectedTextureInLabel;
      if (val.id === labelId) {
        val.textures.map((item) => {
          let itemCopy = JSON.parse(JSON.stringify(item));
          itemCopy["active"] = false;
          const newDefTextures = defaultTextures.map((def) => def.id);
          const index = newDefTextures.indexOf(itemCopy.id);
          if (index !== -1) {
            defaultTextures.splice(index, 1);
          }
          if (itemCopy.id === textureId.id) {
            selectedTextureInLabel = itemCopy;
            defaultTextures.push({
              id: textureId.id,
              renderId: textureId.render_id,
              sceneTextureId: textureId?.scenetexturerender_id,
            });
            itemCopy["selected"] = true;
          } else {
            itemCopy["selected"] = false;
          }
          return null;
        });
        if (selectedTextureInLabel) {
          val["selectedTexture"] = selectedTextureInLabel;
        }
      }
      return null;
    });
    if (
      isEqual(label, labels) &&
      isEqual(selectedTextures.sort(), defaultTextures.sort())
    ) {
      return;
    }
    setLabel(labels);
    setSelectedTextures(defaultTextures);
    APIData = [];
    try {
      if (!outerLoader) {
        showLoader();
      }
      // Re-merge every view so both the main viewer and the thumbnails reflect
      // the new configuration.
      const mergeResults = await Promise.all(
        sceneBackround.map(async (list) => {
          const res = await getAllMergeData({
            mergeData: singleMergeData,
            textureIds: defaultTextures,
            sceneView: list?.id,
          });
          return res ? { view: list, data: res } : null;
        })
      );
      const validResults = mergeResults.filter(Boolean);

      const imagesMap = {};
      const uniqueIdMap = {};
      validResults.forEach(({ view, data }) => {
        imagesMap[view.id] = data?.images || [];
        uniqueIdMap[view.id] =
          data?.unique_id || data?.default_merge_data_copy?.unique_id || "";
      });
      setViewImagesMap(imagesMap);
      setViewUniqueIdMap(uniqueIdMap);
      setViewsList(sceneBackround);

      const threeSixtyData = validResults
        .filter(({ view }) => view?.config_type === "2")
        .map(({ data }) => data);
      uniqueIdData =
        validResults.find(({ view }) => view?.config_type === "2")?.data || null;

      // Refresh whatever view is currently displayed.
      const currentView =
        sceneBackround.find(
          (v) => parseInt(v.id) === parseInt(selectedViewId)
        ) || sceneBackround.find((v) => v?.config_type === "2");
      if (currentView && currentView?.config_type !== "2") {
        // A static view is selected — keep showing it, refreshed.
        setIsStaticView(true);
        setAllImages(imagesMap[currentView.id] || []);
        setCurrentFrame(0);
      } else {
        setIsStaticView(false);
        updateImages({ data: threeSixtyData });
      }
      loadedImage();
    } catch (error) {
      console.error("Error occurred while uploading image:", error);
    }
  };

  const getSingleMergeData = async () => {
    const payload = {
      ...zoomPayload,
    };
    const zoomImages = handleFilterAllImage();
    payload.seq_no = (zoomImages[currentFrame] || zoomImages[0])?.seq_no ?? 0;
    // Pin the payload to the currently selected view so zoom never mixes data
    // from other views (zoomPayload is a shared global set during merges and can
    // hold whichever view finished its merge last).
    if (selectedViewId) {
      payload.scene_view = selectedViewId;
    }
    const selectedViewUniqueId = viewUniqueIdMap?.[selectedViewId];
    payload.unique_id = selectedViewUniqueId
      ? selectedViewUniqueId
      : uniqueIdData
      ? uniqueIdData?.unique_id || uniqueIdData?.default_merge_data_copy?.unique_id
      : selectedTextureMergeId;
    const formData = objectToFormData(payload, { separateArrayItems: true });
    try {
      setSingleMergeLoader(true);
      let url =
        API_ROOT_URL + "/configurator/api/v2/single-merge/v2/?token=" + modelId;
      const response = await axios.post(url, formData);
      setTimeout(() => {
        setSingleMergeLoader(false);
      }, 500);
      const data = response?.data?.data;
      if (data) {
        updateImages({ data:[data] , zoom:true });
        loadedImage();
      }
    } catch (err) {
      errorToastV2("Something went wrong. Please try again.");
      setTimeout(() => {
        setSingleMergeLoader(false);
      }, 500);
    }
  };

  const updateImages = ({ data , zoom=false }) => {
    let allData = [];
    data.map((val) => {
      allData = [...allData, ...val.images];
    });
    APIData = zoom ? allData : [...APIData, ...allData];
    if (data) {
      let imagesToSet = JSON.parse(JSON.stringify(APIData));
      setAllImages(imagesToSet);
      setAllImagesCopy(imagesToSet);
      if (zoom) {
        const zoomFrame = imagesToSet[currentFrame] || imagesToSet[0];
        setZoomedImage(
          zoomFrame?.jpg_image || zoomFrame?.jpg_image_low
        )
        backgroundLoader(
          zoomFrame?.jpg_image || zoomFrame?.jpg_image_low
        )
        setSingleMergeLoader(false);
      }
      if (!isImageViewer) {
        const images = [];
        APIData.forEach((image) => {
          images.push(image?.jpg_image_low || image.image_low);
        });
        setThreeSixtyImages(images);
      }
      if (+currentFrame >= imagesToSet?.length) {
        setCurrentFrame(0);
      }
    }
  };

  const getAllMergeData = async ({ mergeData, textureIds, sceneView }) => {
    const allTextures = textureIds || selectedTextures;
    const textures = allTextures?.map((val) => val?.id);
    const renders = allTextures?.map((val) => val?.renderId);
    const sceneTextureRender = allTextures?.map((val) => val?.sceneTextureId);
    const data = {
      textures: textures,
      renders: renders,
      is_render: true,
      scenetexture_render: sceneTextureRender,
      scene_view: sceneView,
      scene: mergeData?.scene,
      store: mergeData?.store,
      ext: "png",
    };
    zoomPayload = data
    const formData = objectToFormData(data, { separateArrayItems: true });
    try {
      let url =
        API_ROOT_URL + "/configurator/api/v2/merge/v2/?token=" + modelId;
      const response = await axios.post(url, formData);
      const data = response?.data?.data;
      return data;
    } catch (err) {
      errorToastV2("Something went wrong. Please try again.");
      loadedImage();
    }
  };

  const getAllMergeDataMultiLabel = async (data) => {
    // console.log("data", data);
    if(!modelId) return null
    setIsLoading(true)
    const payload = new URLSearchParams();

    for (const key in data) {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach(item => payload.append(key, item));
      } else {
        payload.append(key, value);
      }
    }
    try {
      const url = `${API_ROOT_URL}/configurator/api/v2/merge/v2/?token=${modelId}`;
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      const response = await axios.post(url, payload, config);
      const data = response?.data?.data;
      // return responseData;
       if (Object?.keys(data)?.length) {
        updateImages({ data:[data] , zoom:true });
        loadedImage();
      }else{
        loadedImage();
      }
      setIsLoading(false)
    } catch (err) {
      console.error("API Error:", err);
      errorToastV2("Something went wrong. Please try again.");
      loadedImage();
      setIsLoading(false)
    }
  };

  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  const handleDownload = (imageType) => {
    const mainImage = handleFilterAllImage()[currentFrame]?.image;
    // if (!mainImage) {
    //   const callback = (images) => {
    //     loadImageForDownload(images, imageType);
    //   };
    //   getSingleMergeData(callback);
    // } else {
    //   loadImageForDownload(handleFilterAllImage(), imageType);
    // }
    loadImageForDownload(handleFilterAllImage(), imageType);
  };

  const loadImageForDownload = (images, imageType) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const imgWidth = imageNaturalDimensions?.width;
      const imgHeight = imageNaturalDimensions?.height;
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      context.drawImage(img, 0, 0, imgWidth, imgHeight);
      downloadMergedImage(context, imageType);
    };
    img.src = imageType === "jpeg" ? images[currentFrame].jpg_image || images[currentFrame]?.jpg_image_low : images[currentFrame].image || images[currentFrame].image_low;
    setShowDownloadPopup(false);
  };

  const downloadMergedImage = (context, imageType) => {
    const imageElem = document.createElement("img");
    imageElem.src = context.canvas.toDataURL(`image/${imageType}`);
    const imageName = `${selectedLayoutData?.name}-${currentFrame}.${imageType}`;
    const anchorTag = document.createElement("a");
    anchorTag.setAttribute("target", "_blank");
    anchorTag.setAttribute("href", imageElem.src);
    anchorTag.setAttribute("download", imageName);
    anchorTag.click();
    setShowDownloadPopup(false);
  };

  const switchToFullScreen = (flag) => {
    setFullScreen(flag);
    if (flag) {
      handle.enter();
    } else {
      handle.exit();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setZoom(false);
        setIsDragging(false);
        // console.log("Exited full screen");
      } else {
        // console.log("Entered full screen");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange); // Safari
    document.addEventListener("mozfullscreenchange", handleFullscreenChange); // Firefox
    document.addEventListener("MSFullscreenChange", handleFullscreenChange); // IE/Edge

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullscreenChange);
    };
  }, []);
  
  const changeImage = (type) => {
    if (isLoading || outerLoader) {
      return;
    }
    let count = currentFrame;
    if (type === "prev") {
      if (count < 0) {
        count = 0;
      } else {
        count = count === 0 ? handleFilterAllImage().length - 1 : count - 1;
      }
    } else {
      if (count > handleFilterAllImage().length - 1) {
        count = handleFilterAllImage().length - 1;
      } else {
        count = count === handleFilterAllImage().length - 1 ? 0 : count + 1;
      }
    }
    setCurrentFrame(count);
  };

  const changeImageDimensions = (event, updateBackgroundSize) => {
    let ZOOM_LEVEL = 1;
    const containerWidth = outerContainerRef?.clientWidth;
    let imgWidth = 1;
    let imgHeight = 1;
    if (highResImageWidth * ZOOM_LEVEL > containerWidth) {
      imgWidth = highResImageWidth * ZOOM_LEVEL;
      imgHeight = highResImageHeight * ZOOM_LEVEL;
    } else {
      try {
        ZOOM_LEVEL += 0.01;
      } catch (e) {}
      imgWidth = highResImageWidth * ZOOM_LEVEL;
      imgHeight = highResImageHeight * ZOOM_LEVEL;
    }
    if (event?.target) {
      event.target.height = imgHeight;
      event.target.width = imgWidth;
    }
    if (updateBackgroundSize && event?.target) {
      let width = imgWidth / 3.33;
      let height = imgHeight / 3.33;
      if (width <= imageDimensions?.width) {
        width = imageDimensions.width * 2.5;
      }
      if (height <= imageDimensions?.height) {
        height = imageDimensions.height * 2.5;
      }

      let _height = height;
      if (fullScreen && window.innerHeight > _height) {
        _height = window.innerHeight;
      }
      if (event?.target) {
        event.target.style.width = `${isMobile ? width : imgWidth}px`;
        event.target.style.height = `${isMobile ? _height : imgHeight}px`;
      }
    }
  };

  const handleGetLink = (value) => {
    const id = selectedFinishType[value]?.id
    switch (+id) {
      // rug
      //"Bellfort Blue Grey"
      case 145980:
        return "https://www.feizy.com/8698776f"
      //"Bleeker Slate"
      case 145982:
        return "https://www.feizy.com/6173602f"
      //"Asher Tauper"
      case 145983:
        return "https://www.feizy.com/8638768f"
      //"Gray ivory"
      case 146004:
        return "https://www.feizy.com/8643874f"
      //"Brixton Atlantic"
      case 146008:
        return "https://www.feizy.com/6173602f"
        // BBE
      //"69 FVF Ivory-Grey"
      case 147622:
        return "https://www.feizy.com/els69fvf"
      //"69 FZF Grey-Multi"
      case 147623:
        return "https://www.feizy.com/kas69fzf"
      //"8952F Beige-Ivory"
      case 147624:
        return "https://www.feizy.com/plk8952f"
      //"39 FJF Beige-Charcoal"
      case 147626:
        return "https://www.feizy.com/vnr39fjf"
      //"0563F Charcoal-Multi"
      case 147625:
        return "https://www.feizy.com/ley0563f"

        // TLRV
         //"6501F Gold-Light Blue"
      case 147635:
        return "https://www.feizy.com/9826501f"
         //"6502F Light Blue-Beige"
      case 147636:
        return "https://www.feizy.com/9826502f"
         //"6817F Beige-Blue"
      case 147637:
        return "https://www.feizy.com/mar6817f"
         //"6941F Blue-Charcoal"
      case 147638:
        return "https://www.feizy.com/fil6941f"
         //"6503F Green-Grey"
      case 147639:
        return "https://www.feizy.com/9826503f"


        // MLRLG
         //"0629F Black-White"
      case 147630:
        return "https://www.feizy.com/5940629f"
         //"6032L Grey-Gold"
      case 147631:
        return "https://www.feizy.com/5386032l"
         //"6072F Beige"
      case 147632:
        return "https://www.feizy.com/5056072f"
         //"8628F Pewter"
      case 147633:
        return "https://www.feizy.com/7178628f"
         //"69D6F Charcoal-Rust"
      case 147634:
        return "https://www.feizy.com/lsn69d6f"
      default:
        return 'https://www.feizy.com/'
    }
  }

  const handleGetURL = (label) => {
    const labelName = label?.value || label
    switch (labelName?.toLowerCase?.()?.trim()) {
      case "rug":
        return handleGetLink(labelName)
      case "trim":
        return handleGetLink(labelName)
      case "cushion":
        return handleGetLink(labelName)
        default:
        return "https://www.feizy.com/";
    }
  };

  const hotspot = () => {
    return (
      <div className="hotspot-dot">
        {hobSpotLabel?.length > 0 &&
          hobSpotLabel?.map((label, index) => {
            if(!hubSpotImagePosition?.[currentFrame]?.style?.[index]){
              return null
            }
            return (
              <React.Fragment key={index}>
                <span
                  {...(index === 0 && { ref: hutSpotTooltipTarget })}
                  className={`${!reverse ? "reverse-color" : ""} ${
                    selectedHubSpot === label ? "active" : ""
                  }`}
                  style={hubSpotImagePosition?.[currentFrame]?.style?.[index]}
                  onMouseEnter={() => setShowDetails(label)}
                  onMouseLeave={() => setShowDetails(null)}
                  onClick={() => setSelectedHubSpot(label)}
                  onTouchStart={() => setSelectedHubSpot(label)}
                >
                  {showDetails === label && (
                    <span
                      onMouseEnter={() => setShowDetails(label)}
                      onMouseLeave={() =>
                        selectedHubSpot !== label && setShowDetails(null)
                      }
                      onClick={() => setSelectedHubSpot(label)}
                      className={`applyed ${
                        +hubSpotImagePosition?.[currentFrame]?.style?.[
                          index
                        ]?.left.replace("%", "") > 70
                          ? "position-left"
                          : ""
                      }`}
                    >
                      <span />
                      <span>
                        {" "}
                        <span>{getOptionImageAndText(label)}</span>
                        {handleGetURL(label) && (
                          <button className="shopBtn">
                            <a href={handleGetURL(label)} target="_blank">
                              Shop This Product
                            </a>
                          </button>
                        )}
                      </span>
                    </span>
                  )}
                </span>

                {index === 0 && (
                  <Overlay
                    target={hutSpotTooltipTarget?.current}
                    show={showTooltips.hotspotTooltip}
                    placement="right"
                    key="overlay"
                  >
                    {(props) => (
                      <Tooltip {...props}>
                        tap on a hotspot to apply selected fabric.
                        <BigButton
                          variant="link"
                          className="ms-auto"
                          onClick={() => {
                            setShowTooltips({
                              ...showTooltips,
                              hotspotTooltip: false,
                            });
                            setLocalStorage(HOTSPOT_TOOLTIP_KEY, false);
                          }}
                        >
                          Got it
                        </BigButton>
                      </Tooltip>
                    )}
                  </Overlay>
                )}
              </React.Fragment>
            );
          })}
      </div>
    );
  };

  const downloadIconContainer = (hidePosition) => {
    return (
      <div
        className={`downloadIcon-icon ${hidePosition ? "" : "position-absolute"}`}
        title="Download Image"
        // onClick={() => {
        //   // if (isLoading || outerLoader) {
        //   //   return
        //   // }
        //   // setShowDownloadPopup(!showDownloadPopup)
        //   handleDownload('jpeg');
        // }}
        onClick={() => handleDownload("jpeg")}
      >
        {/* <DownloadIcon /> */}
        {/* <ScreenShotIcon/> */}
         <img
          src="buttons/skin-button-IMAGE.png"
          alt="download"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-normal"
        />
        <img
          src="buttons/skin-button-IMAGE-HOVER.png"
          alt="download"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-hover"
        />
        
      </div>
    )
  };

  const doubleClickZoom = () => {
    return (
      <div
        className={`bottom-thumnail-section w-auto position-absolute d-flex justify-content-center align-items-end ${isMobileAr ? "mobile" : ""}`}
      >
        <span className={`zoom-text px-3 py-1 m-px-0 text-center doubleClickText noSelect`}>
          {zoom
            ? "Drag to Move. Double Click to ZOOM OUT."
            : isStaticView
            ? "Double Click to ZOOM IN."
            : "Drag to ROTATE. Double Click to ZOOM IN."}
        </span>
      </div>
    );
  };

  // Returns the representative thumbnail url for a view (the loading-angle frame
  // for a 360 view, otherwise its single image).
  const getViewThumbUrl = (view) => {
    const imgs = viewImagesMap[view?.id] || [];
    if (!imgs.length) return null;
    const idx =
      view?.config_type === "2"
        ? Math.min(view?.loading_angle || 0, imgs.length - 1)
        : 0;
    const frame = imgs[idx] || imgs[0];
    return frame?.jpg_image_low || frame?.image_low || frame?.jpg_image;
  };

  // console.log(viewsList, "viewsListviewsList");
  const viewThumbnails = () => {
    if (zoom || !viewsList?.length || viewsList.length < 2) return null;
    return (
      <div className={`view-thumbnails position-absolute d-flex align-items-center ${isMobileAr ? "mobile" : ""}`}>
        {viewsList.map((view) => {
          const thumbUrl = getViewThumbUrl(view);
          if (!thumbUrl) return null;
          return (
            <div
              key={view.id}
              className={`view-thumb ${
                parseInt(selectedViewId) === parseInt(view.id) ? "active" : ""
              } ${isMobileAr ? "mobile" : ""}`}
              title={view?.name}
              onClick={() => selectView(view)}
            >
              <img
                src={thumbUrl}
                alt={view?.name || "view"}
                crossOrigin="anonymous"
              />
              {view?.config_type === "2" && (
                <div className="view-thumb-badge">
                  <svg
                    viewBox="0 0 24 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse
                      cx="12"
                      cy="8"
                      rx="10"
                      ry="4.2"
                      stroke="#fff"
                      strokeWidth="1.3"
                    />
                    <path
                      d="M6.4 4.7 L3.7 5.1 L5 7.5"
                      stroke="#fff"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.6 11.3 L20.3 10.9 L19 8.5"
                      stroke="#fff"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>360</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const VisibleToggleIcon = () => {
    return (
      <div
        className="position-absolute visible-icon"
        onClick={() => setVisible(!visible)}
      >
        {visible ? <VisibilityOff /> : <Visibility />}
      </div>
    );
  };
  // console.log(currentFrame)
  // console.log(selectedLayoutData,"selectedLayoutData");
  // console.log(selectedScene,"selectedScene");

  const HandlePDF = async () => {
    //console.log("Generating PDF");

    const pdf = new jsPDF("p", "mm", "a4"); // Portrait, millimeters, A4 size
    pdf.addFileToVFS('Assistant-Bold.ttf', AssistantBold);
    pdf.addFileToVFS('Assistant-Regular.ttf', AssistantNormal);
    pdf.addFileToVFS('Assistant-SemiBold.ttf', AssistantSemibold);
    pdf.addFileToVFS('GFSDidot-Regular.ttf', GFSDidotRegular);


    pdf.addFont('Assistant-Bold.ttf', 'Assistant', 'bold');
    pdf.addFont('Assistant-Regular.ttf', 'Assistant', 'normal');
    pdf.addFont('Assistant-SemiBold.ttf', 'Assistant', 'semibold');
    pdf.addFont('GFSDidot-Regular.ttf', 'GFSDidot', 'regular');

    // const content = allImages[12]?.jpg_image || allImages[12]?.jpg_image_low || allImages[12]?.image;
    const content = allImages[currentFrame]?.jpg_image || allImages[currentFrame]?.jpg_image_low || allImages[currentFrame]?.image;

    if (!content) {
      console.error("PDF content not found");
      return;
    }
    pdf.setFont('Assistant', 'normal');
    // --- Header section (unchanged) ---
    const logoUrl = "pdfLogoo.png";
    pdf.addImage(logoUrl, "PNG", 10, 10, 75, 15);

    const contactInfo = {
      website: "MaineCottage.com",
      phone: "866.366.3505",
    };
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginRight = 10;
    const contactX = pageWidth - marginRight;

    pdf.setFont("Assistant", "normal");
    pdf.setFontSize(10);
    pdf.setTextColor(35, 31, 32);
    const phoneWidth = pdf.getTextWidth(contactInfo.phone);

    pdf.textWithLink(contactInfo.phone, contactX - phoneWidth, 15, {
      url: `tel:${contactInfo.phone.replace(/-/g, "")}`,
    });

    const websiteWidth = pdf.getTextWidth(contactInfo.website);
    pdf.textWithLink(contactInfo.website, contactX - websiteWidth, 20, {
      url: `${contactInfo.website}`,
    });

    // pdf.setTextColor(0, 0, 0);
    pdf.line(10, 30, 200, 30);

    let yPosition = 50; // Initial start position

    const productName = selectedScene?.name || "Product Name";
    // pdf.setFont('Assistant', 'semibold');
    pdf.setFont("GFSDidot", "regular");

    pdf.setFontSize(28);

    const productNameWidth = pdf.getTextWidth(productName);
    const centeredProductNameX = (pageWidth - productNameWidth) / 2;
    pdf.text(productName, centeredProductNameX, yPosition);
    yPosition += 10; 

    // Add center-aligned labels ---
    if (Array.isArray(label) && label.length > 0) {
      label.forEach((item) => {
        if (item.name && item.selectedTexture?.display_name) {
          pdf.setFont('Assistant', 'bold'); 
          pdf.setFontSize(8);
          // pdf.setTextColor(0, 0, 0);
          const labelName = `FEATURED ${item.name.toUpperCase()}:`;
          const labelNameWidth = pdf.getTextWidth(labelName);
          const centeredLabelX = (pageWidth - labelNameWidth) / 2;
          pdf.text(labelName, centeredLabelX, yPosition);
          yPosition += 4; 

          pdf.setFont('Assistant', 'normal');
          pdf.setFontSize(10);
          const valueText = item.selectedTexture.display_name;
          const valueWidth = pdf.getTextWidth(valueText);
          const centeredValueX = (pageWidth - valueWidth) / 2;
          
          let url = redirectURL1.find(
            ({ name }) => name === valueText
          )?.url;
          
          if (url) {
            // pdf.setTextColor(0, 0, 255);
            pdf.textWithLink(valueText, centeredValueX, yPosition, { url: url });
          } else {
            // pdf.setTextColor(0, 0, 0);
            pdf.text(valueText, centeredValueX, yPosition);
          }
          yPosition += 8;
        }
      });
    } else {
      console.warn("Label array is empty or invalid");
    }

    const img = new Image();
    img.src = content;
    img.onload = function () {
      const maxWidth = 190;
      const maxHeight = 170;
      let imgWidth = img.width;
      let imgHeight = img.height;
      const aspectRatio = imgWidth / imgHeight;

      if (imgWidth > maxWidth || imgHeight > maxHeight) {
        if (imgWidth / maxWidth > imgHeight / maxHeight) {
          imgWidth = maxWidth;
          imgHeight = maxWidth / aspectRatio;
        } else {
          imgHeight = maxHeight;
          imgWidth = maxHeight * aspectRatio;
        }
      }
      
      let positionX = (pageWidth - imgWidth) / 2; // Center horizontally
      let positionY = yPosition + 5; 
      
      pdf.addImage(img, "PNG", positionX, positionY, imgWidth, imgHeight);
      pdf.setFont('Assistant', 'normal');
      pdf.setFontSize(10);
      let textBlockY = positionY + imgHeight + 10; 

      const line1 = "For product questions please call or email customer care at";
      const line1Width = pdf.getTextWidth(line1);
      const line1X = (pageWidth - line1Width) / 2;
      pdf.text(line1, line1X, textBlockY);
      textBlockY += 5;

      const email = "customercare@mainecottage.com";
      const separator = " or ";
      const phone = "866-366-3505.";

      const emailWidth = pdf.getTextWidth(email);
      const separatorWidth = pdf.getTextWidth(separator);
      const phoneWidth = pdf.getTextWidth(phone);
      const totalLineWidth = emailWidth + separatorWidth + phoneWidth;
      let currentX = (pageWidth - totalLineWidth) / 2; 

      pdf.textWithLink(email, currentX, textBlockY, { url: `mailto:${email}` });
      currentX += emailWidth; 

      pdf.text(separator, currentX, textBlockY);
      currentX += separatorWidth; 

      pdf.text(phone, currentX, textBlockY);

      const footerContent = "footerContent.png";
      const footerWidth = 100;
      const footerHeight = 15;
      const footerX = (pageWidth - footerWidth) / 2;
      const footerY = pageHeight - footerHeight - 10;
      pdf.line(10, footerY-5, 200, footerY-5);
      pdf.addImage(footerContent, "PNG", footerX, footerY + 5, footerWidth, footerHeight);

      pdf.save(`Maine-Cottage_${selectedScene?.name || 'maineCottage'}.pdf`);
    };

  };

  const PDFIcon = (hidePosition) => {
    return (
      <div className={`${hidePosition ? "" : "position-absolute"} pdf-icon`} title="Download pdf" onClick={() => HandlePDF()}>
        {/* <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.1875 4.6875H16.6875V0.1875H2.4375V10.6875H3.9375V1.6875H15.1875V6.1875H19.6875V22.3125H2.4375V23.8125H21.1875V4.6875Z"
            fill="#6b8faf"
          />
          <path
            d="M2.88745 13.3501H5.58745C6.0937 13.3501 6.44995 13.4251 6.71245 13.5751C6.9562 13.7251 7.12495 13.9501 7.2187 14.2501C7.31245 14.5501 7.34995 14.9626 7.34995 15.5063C7.34995 16.0126 7.31245 16.4063 7.23745 16.7063C7.16245 17.0063 6.9937 17.2313 6.7312 17.4001C6.4687 17.5688 6.0937 17.6438 5.58745 17.6438H4.7437V19.5188H2.88745V13.3501ZM4.98745 16.2751C5.1562 16.2751 5.2687 16.2563 5.32495 16.2376C5.3812 16.2188 5.43745 16.1438 5.4562 16.0501C5.47495 15.9563 5.4937 15.7688 5.4937 15.5063C5.4937 15.2438 5.47495 15.0751 5.4562 14.9626C5.43745 14.8688 5.39995 14.7938 5.32495 14.7751C5.24995 14.7563 5.1562 14.7376 4.98745 14.7376H4.7437V16.2751H4.98745Z"
            fill="#6b8faf"
          />
          <path
            d="M7.91235 13.3501H9.9561C10.7811 13.3501 11.3436 13.4438 11.6811 13.6126C12.0186 13.7813 12.2249 14.0813 12.3186 14.4563C12.3936 14.8501 12.4311 15.5063 12.4311 16.4438C12.4311 17.3813 12.3936 18.0376 12.3186 18.4313C12.2436 18.8251 12.0186 19.1063 11.6811 19.2751C11.3436 19.4438 10.7624 19.5376 9.9561 19.5376H7.91235V13.3501ZM9.97485 18.1313C10.1999 18.1313 10.3311 18.1126 10.4061 18.0563C10.4811 18.0001 10.5186 17.8688 10.5374 17.6813C10.5561 17.4938 10.5561 17.0813 10.5561 16.4626C10.5561 15.8438 10.5561 15.4313 10.5374 15.2251C10.5186 15.0188 10.4811 14.8876 10.4061 14.8501C10.3311 14.7938 10.1811 14.7751 9.9561 14.7751H9.7311V18.1501H9.97485V18.1313Z"
            fill="#6b8faf"
          />
          <path
            d="M13.1812 19.5376V13.3501H16.8749V14.7563H15.0374V15.9376H16.6124V17.3438H15.0374V19.5376H13.1812Z"
            fill="#6b8faf"
          />
        </svg> */}
         <img
          src="buttons/skin-button-PDF.png"
          alt="Pdf"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-normal"
        />
        <img
          src="buttons/skin-button-PDF-HOVER.png"
          alt="Pdf"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-hover"
        />
      </div>
    );
  };

  const fullScreenIcon = () => {
    return (
      <div
        className="position-absolute fullscreen-icon"
        onClick={() => {
          if (isLoading || outerLoader) {
            return;
          }
          switchToFullScreen(!fullScreen);
          setZoom(false);
          setZoomHoverStyle({ x: 0, y: 0 });
        }}
      >
        <FullScreenIcon className="unselectable" />
      </div>
    );
  };

  const ArViewButton = () => {
    return (
      <div
        className={`ar-icon ${isMobileAr ? 'mobile' : ''}`}
        onClick={() => {
            setTimeout(() => {
                console.log("clicked");
                setApiLoading(true);
                setIsAR(true);
            },500)
        }}
      >
        <img
          src="buttons/skin-button-AR.png"
          alt="AR"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-normal"
        />
        <img
          src="buttons/skin-button-AR-HOVER.png"
          alt="AR"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-hover"
        />
        
        {/* <ArIcon /> */}
        {/* {!isMobileAr && <span>View AR</span>} */}
      </div>
    );
  };

  const leftRightIcon = () => {
    const prevDisabled = +currentFrame === 0;
    const nextDisabled = +currentFrame + 1 === handleFilterAllImage().length;
    return (
      <>
        <div className="image-action-area" ref={viewTooltipTarget}>
          <div
            className={`left-nav nav-buttons ${
              prevDisabled ? "icon-disabled" : ""
            }`}
          >
            <LeftIcon onClick={() => !prevDisabled && changeImage("prev")} />
          </div>
          <div className="image-count noSelect">
            {currentFrame + 1} / {totalViews || handleFilterAllImage().length}
          </div>
          <div
            className={`right-nav nav-buttons ${
              nextDisabled ? "icon-disabled" : ""
            }`}
          >
            <RightIcon onClick={() => !nextDisabled && changeImage("next")} />
          </div>
        </div>
      </>
    );
  };

  const getImageConfImage = (frame) => {
    return frame?.jpg_image || frame?.jpg_image_low || frame?.image_low;
  };

  const loadedImage = (e) => {
    hideLoader();
    setOuterLoader(false);
  };

  const getMeasureToolIcon = (hidePosition) => {
    // Measure tool only applies to the 360 view — fade it out and disable clicks
    // on static views instead of hiding it.
    return (
      <div
        className={`${hidePosition ? "" : "position-absolute"} measure-icon iconBtn ${
        measureTool && 'activeIcon'
      } ${isStaticView ? 'icon-disabled' : ''}`}
        title="Measure Tool"
        onClick={() => !isStaticView && setMeasureTool(!measureTool)}
      >
        {/* <MeasureIcon/> */}
        <img
          src="buttons/skin-button-DIMS.png"
          alt="Measure"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-normal"
        />
        <img
          src="buttons/skin-button-DIMS-HOVER.png"
          alt="Measure"
          height="auto"
          width="40"
          style={{ margin: 0 }}
          crossOrigin="anonymous"
          className="icon-hover"
        />
      </div>
    )
  }

  const autoRotateHandler = () => {
    setAutoPlay360(!autoPlay360);
  };

  const autoRotateContainer = () => {
    return (
      <div
        className={`autoRotate-icon iconBtn ${autoPlay360 && "activeIcon"}`}
        title="Auto Rotate"
        // onClick={autoRotateHandler}
      >
        <AutoRotateIcon />
      </div>
    );
  };

  const handleShowVerticalMenu = () => {
    return (
      <div className="verticalIcon">
        {showArButton && ArViewButton()}
        {/* {ArViewButton()} */}
        {showMeasureTool && getMeasureToolIcon(true)}
        {downloadIconContainer(true)}
        {PDFIcon(true)}
        {/* {autoRotateContainer()} */}
      </div>
    );
  };

  const getRelativeComponents = () => {
    return (
      <>
        {fullScreen ? (
          <div
            onClick={() => switchToFullScreen(!fullScreen)}
            className="close-full-screen"
          >
            <Close />
          </div>
        ) : (
          <>
            {!zoom &&
              isImageViewer &&
              (totalViews > 1 || handleFilterAllImage().length > 1) &&
              leftRightIcon()}
            {/* {PoweredByIcon()} */}
            {/* {VisibleToggleIcon()} */}
            {handleShowVerticalMenu()}
            {!isMobileAr && fullScreenIcon()}
            {/* {showArButton && ArViewButton()} */}
            {/* {ArViewButton()} */}
            {/* {hideSwatch ? null : handleShowImage()} */}
            {doubleClickZoom()}
            {visible && hotspot()}
          </>
        )}
      </>
    );
  };

  const calculateFullScreenDimensions = (elem) => {
    if (!elem) {
      return;
    }
    if (fullScreen) {
      // timeout is needed to as updated dimensions are coming
      setTimeout(() => {
        const fullScreenHeightWidth = calculateAspectRatioFit(
          imageNaturalDimensions.width,
          imageNaturalDimensions.height,
          imageViewerRef?.current?.clientWidth,
          imageViewerRef?.current?.clientHeight
        );
        elem.style.height = `${fullScreenHeightWidth?.height}px`;
        elem.style.width = `${fullScreenHeightWidth?.width}px`;
      }, 70);
    } else {
      elem.style.height = `100%`;
      elem.style.width = `100%`;
    }
  };

  const getZoomImage = () => {
    return (
      <div className={`${!zoom ? "hide-overlap" : ""}`}>
        <div
          className={`image-zoom-overlap bg-white position-absolute
          ${isMobileAr ? "mobile-hover-effect" : ""}
          ${isDragging ? "dragging" : ""}
        `}
          ref={zoomImageRef}
          style={{
            transform: `translate(${zoomHoverStyle.x}px, ${zoomHoverStyle.y}px)`,
            transformOrigin: `calc(${zoomHoverStyle.x} * -1) calc(${zoomHoverStyle.y} * -1)`,
            backgroundSize: "cover",
          }}
          onMouseMove={(e) => handleMouseMove2(e, 1)}
          onTouchMove={(e) => handleMouseMove2(e, 1)}
          onTouchStart={(e) => {
            setIsDragging(true);
            setDragStart({
              x: e.touches[0].clientX - zoomHoverStyle.x,
              y: e.touches[0].clientY - zoomHoverStyle.y,
            });
          }}
          onTouchCancel={(e) => {
            setIsDragging(false);
            setDragStart({
              x: e.touches[0].clientX - zoomHoverStyle.x,
              y: e.touches[0].clientY - zoomHoverStyle.y,
            });
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsDragging(true);
            setDragStart({
              x: e.clientX - zoomHoverStyle.x,
              y: e.clientY - zoomHoverStyle.y,
            });
          }}
          onMouseUp={(e) => {
            setIsDragging(false);
          }}
          onDoubleClick={(e) => {
            handleMouseMove(e);
            setZoom(false);
            setIsDragging(false);
          }}
        ></div>
         {singleMergeLoader && (
          <div className="progress-bar-single-merge position-absolute w-100">
            <div className="progress-bar-value-single-merge w-100 h-100" />
          </div>
        )}
      </div>
    );
  };

  const handleMouseMove = (e) => {
    const event = e?.touches?.length ? e?.touches[0] : e;
    const { left, top } = event.target.getBoundingClientRect();
    const conainterWidth = imageViewerRef?.current?.clientWidth;
    const conainterHeight = imageViewerRef?.current?.clientHeight;
    const imageWidth = parseFloat(
      zoomImageRef?.current?.style?.width?.replace("px", ""),
      0
    );
    const imageHeight = parseFloat(
      zoomImageRef?.current?.style?.height?.replace("px", ""),
      0
    );
    let x =
      -(event.clientX - left) *
      ((imageWidth - conainterWidth) / conainterWidth);
    let y =
      -(event.clientY - top) *
      ((imageHeight - conainterHeight) / conainterHeight);
    if (x > 0) x = 0;
    else if (x - conainterWidth < -imageWidth)
      x = -(imageWidth - conainterWidth);
    if (y > 0) y = 0;
    else if (y - conainterHeight < -imageHeight)
      y = -(imageHeight - conainterHeight);
    setZoomHoverStyle({ x: x, y: y });
  };

  const handleMouseMove2 = (e, speed = 1) => {
    if (!isDragging) return;
    const event = e?.touches?.length ? e?.touches[0] : e;
    if (event.clientX === 0 && event.clientY === 0) return;
    const conainterWidth = imageViewerRef?.current?.clientWidth;
    const conainterHeight = imageViewerRef?.current?.clientHeight;
    const imageWidth = parseFloat(
      zoomImageRef?.current?.style.width?.replace("px", ""),
      0
    );
    const imageHeight = parseFloat(
      zoomImageRef?.current?.style.height?.replace("px", ""),
      0
    );
    let x = -(dragStart.x - event.clientX) * speed;
    let y = -(dragStart.y - event.clientY) * speed;
    if (x > 0) x = 0;
    else if (x - conainterWidth < -imageWidth)
      x = -(imageWidth - conainterWidth);
    if (y > 0) y = 0;
    else if (y - conainterHeight < -imageHeight)
      y = -(imageHeight - conainterHeight);
    setZoomHoverStyle({ x: x, y: y });
  };

  const backgroundLoader = (url) => {
    const image = new Image();
    image.onload = function () {
      if (zoomImageRef?.current?.style) {
        zoomImageRef.current.style.backgroundImage = "url('" + url + "')";
      }
      changeImageDimensions({ target: zoomImageRef?.current });
    };
    image.src = url;
  };

  const zoom360Image = async ({ e = null, images = [] }) => {
    if (isLoading || outerLoader || zoom) {
      return;
    }
    const allImagesList =
      images.length > 0 ? [...images] : [...handleFilterAllImage()];
    // const event = e?.touches?.length ? e?.touches[0] : e;
    changeImageDimensions({ target: zoomImageRef?.current }, true);
    if (e) handleMouseMove(e);
    setZoom(true);
    if (!allImagesList[currentFrame]?.jpg_image) {
       setZoomedImage(allImagesList[currentFrame]?.jpg_image || allImagesList[currentFrame]?.jpg_image_low ||  allImagesList[currentFrame]?.image_low);
       getSingleMergeData()
       setZoomedImage(allImagesList[currentFrame]?.jpg_image || allImagesList[currentFrame]?.jpg_image_low ||  allImagesList[currentFrame]?.image_low);
       backgroundLoader(
        allImagesList[currentFrame]?.jpg_image || allImagesList[currentFrame]?.jpg_image_low ||
          allImagesList[currentFrame]?.image_low
      );
    } else {
      setZoomedImage(allImagesList[currentFrame]?.jpg_image || allImagesList[currentFrame]?.jpg_image_low || allImagesList[currentFrame]?.image);
      backgroundLoader(allImagesList[currentFrame]?.jpg_image || allImagesList[currentFrame]?.jpg_image_low || allImagesList[currentFrame]?.image);
    }
  };

  const downloadImageContainer = (hidden = false) => {
    const backgroundStyle = {
      backgroundImage:`url('${loadedLowResImage || allImages[currentFrame]?.[`image['jpg_image_low']`] || allImages[currentFrame]?.[`image['jpg_image']`]}')`,
    };
    backgroundStyle.backgroundSize = 'contain';
    
    return (
      <div
        className={`h-100 w-100 ${hidden ? 'position-absolute image-layer' : 'position-relative'}`}>
        <div
          className={`fullscreenCanvas image-normal image-layer`}
          // style={!isFullScreen ? backgroundStyle : {}}
          style={backgroundStyle}
          onDoubleClick={(e) => zoom360Image({ e })}>
        </div>
      </div>
    );
  };

  const getLeftSideContentImageConf = (isFullScreen = false) => {
    return (
      <>
        {!!handleFilterAllImage()?.length && (
          <div
            className={`w-100 flex-fill d-flex flex-column image-preview ${
              zoom ? "unselectable" : ""
            } ${isFullScreen ? "fullScreenImage" : "position-relative"} ${
              !isMobile ? "h-100 top0" : ""
            } ${
              isFullScreen && isMobile ? "overflow-hide" : ""
            } overflow-hidden`}
            ref={imageViewerRef}
          >
            <div
              className={`image-normal flex-fill position-relative ${
                fullScreen ? "w-100 h-100 contain" : ""
              }`}
              style={{
                backgroundImage: `url('${loadedLowResImage}')`,
              }}
              ref={(elem) => {
                calculateFullScreenDimensions(elem);
              }}
              onDoubleClick={(e) => {
                zoom360Image({ e });
              }}
            >
              <div
                className="position-absolute bottom-0 start-50 translate-middle-x px-1 d-flex justify-content-center align-items-center"
                style={{
                  borderTopRightRadius: "4px",
                  borderTopLeftRadius: "4px",
                  backgroundColor: "rgba(255,255,255,0.25)",
                  zIndex: "999",
                }}
                // onClick={() => {
                //   window.open("https://www.imagine.io", "_blank");
                // }}
              >
                <div className="noSelect" style={{ fontSize: "8px" }}>
                  powered by &nbsp;
                </div>
                <img
                  className="noSelect"
                  src="/favicon.png"
                  style={{ width: "8px", height: "8px" }}
                />
                <div className="noSelect" style={{ fontSize: "8px", color: "#ec4f0c" }}>
                  &nbsp;imagine.io
                </div>
              </div>
            </div>
            {getZoomImage()}
            {(isLoading || progressiveLoading) && (
              <div className="w-100 h-100 d-flex position-absolute justify-content-center align-items-center loader-parent">
                {/* <Loader loading={true} /> */}
                <AnimatedLoader backDrop="transparent" />
              </div>
            )}
            {getRelativeComponents()}
          </div>
        )}
      </>
    );
  };

  const getLeftSideContent360Conf = (isFullScreen = false) => {
    // const zoomImage = handleFilterAllImage()[currentFrame]?.image_low;
    const measureToolStyle = {
      position: 'absolute',
      height: fullScreen ? "100%" : imageDimensions?.height,
      width: fullScreen ? "100%" : imageDimensions?.width,
      top: 0,
      pointerEvents: 'none'
    }
    return (
      <>
        {isLoading && (
          <div className="w-100 h-100 d-flex position-absolute justify-content-center align-items-center loader-parent">
            {/* <Loader loading={true} /> */}
            <AnimatedLoader backDrop="transparent" />
          </div>
        )}
        {!!handleFilterAllImage()?.length && (
          <>
          {!isStaticView && downloadImageContainer(true)}
          <div
            className={`position-relative overflow-hidden cursor-drag fullscreenCanvas ${
              isFullScreen && 'fullScreenImage'
            }`}
            ref={imageViewerRef}
          >
            {isStaticView ? (
              // Static (non-360) view: render the selected frame as a real <img>
              // so it reliably displays (a background-image div was collapsing in
              // this flex layout). Read the url directly from the frame because
              // loadedLowResImage lags behind during a view switch.
              <img
                className={`fullscreenCanvas ${zoom && 'hide-overlap'}`}
                src={
                  handleFilterAllImage()[currentFrame]?.jpg_image_low ||
                  handleFilterAllImage()[currentFrame]?.image_low ||
                  handleFilterAllImage()[currentFrame]?.jpg_image ||
                  loadedLowResImage
                }
                alt={"view"}
                crossOrigin="anonymous"
                style={{
                  objectFit: 'contain',
                  ...(fullScreen ? { width: '100%', height: '100%' } : {}),
                }}
                onDoubleClick={(e) => zoom360Image({ e })}
              />
            ) : (
              <div
                className={`${!fullScreen && 'spritespin-parent'} ${
                  zoom && 'hide-overlap'
                }`}
                ref={spriteSpinRef}
                onDoubleClick={(e) => {
                  zoom360Image({ e })
                  // handleSetXY();
                }}
              />
            )}
               {!zoom && !isStaticView && measureImageList?.length && (
                <div style={measureToolStyle}  className="fullscreenCanvas">
                   {measureImageList?.map((imgData, index) => {
                    return (
                      <img
                        key={index}
                        src={imgData?.url}
                        alt="images"
                        className={`fullscreenCanvas ${
                          index === currentFrame && measureTool
                            ? ''
                            : 'displayNone'
                        }`}
                        height={fullScreen ? '100%' : imageDimensions?.height}
                        width={fullScreen ? '100%' : imageDimensions?.width}
                      />
                    )
                  })}
                </div>
              )}
             {getZoomImage()}
            {!outerLoader && getRelativeComponents()}
          </div>
          </>
        )}
      </>
    )
  };

  const setNewScene = (value) => {
    setSelectedLayoutData(value);
    setSelectedHubSpot(null);
  };

  const sliceImagesList = (data) => {
    if (!selectedScene) {
      return;
    }
    if (data) {
      let dataToOperate = localImageData.find(
        (d) => d.sceneId === selectedScene.id && d.labelId === data
      );
      if (dataToOperate) {
        setMinMaxImgObject(dataToOperate);
        const newImagesList = allImagesCopy?.slice(
          dataToOperate.min,
          dataToOperate.max
        );
        setAllImages(newImagesList);
      }
    } else {
      setMinMaxImgObject(null);
      // setAllImages([...allImagesCopy]);
      allImagesCopy && setAllImages([...allImagesCopy]);
    }
  };

  const getOptionImageAndText = (name) => {
    let option = {};
    if (label?.length) {
      let currentLabel = label.find(
        (previewLabel) => previewLabel.name === name
      );
      if (currentLabel.selectedTexture) {
        option = currentLabel.selectedTexture;
      } else if (currentLabel?.textures?.length) {
        option = currentLabel?.textures[0];
      }
    }
    return option?.display_name;
  };

  const getThemeOtherThemes = (str, isUnityRight = false) => {
    let marginRight = 0;
    if (window.innerWidth < 768 || isFinalise) {
      marginRight = 0;
    } else {
      marginRight =
        outerContainerRef?.current?.clientWidth - imageDimensions?.width;
    }
    return (
      <Row className={`m-0 main-row-height justify-content-center h-100`}>
        <Col
          lg={isFinalise ? 12 : 9}
          sm={12}
          className={`flex-fill d-flex align-items-center px-0 h-100
          ${
            !isFinalise && "image-container"
          } ${
            isFinalise
              ? "justify-content-center"
              : str === "default"
              ? "justify-content-end"
              : isUnityRight
              ? "justify-content-start"
              : "justify-content-end"
          }
          ${
           showSidebar ? 'h-auto' : ''
          }`
        }
          ref={outerContainerRef}
        >
          <div
            className={`flex-fill w-100 position-relative justify-content-center d-flex align-items-center h-100 overflow-y-auto`}
          >
            {!fullScreen && isImageViewer && getLeftSideContentImageConf()}
            {!fullScreen && !isImageViewer && getLeftSideContent360Conf()}
            {/* {!fullScreen && isImageViewer && getAllRenderedImages()} */}
            
            {showViewAngles || showViewAngles === "true" ? viewThumbnails() : null}
          </div>
        </Col>
        {showSidebar || showSidebar === "true" ? (
          <Col lg={3} sm={12} className={`px-0 right-content-height`}>
            <div className="w-100 left-side-menu">
              {!outerLoader && (
                <ConfiguratorThemesSidebar
                  scenePassed={selectedScene}
                  allLabels={label}
                  setNewLabels={(val) => {
                    getDefaultTextures({
                      labelId: val.label,
                      textureId: val.option,
                      isDisabled: val.is_disabled,
                    });
                  }} // needs to update via message
                  // setShowThumbnail={setShowThumbnail}
                  selectedFinishType={selectedFinishType}
                  setSelectedFinishType={setSelectedFinishType}
                  fromViewer={true}
                  allScenes={allScenes}
                  setNewScene={(val) => setNewScene(val)} // needs to update via message
                  setLabel={setLabel}
                  localLayoutData={layoutData}
                  localProfileData={localProfileData}
                  localSceneData={localSceneData}
                  selectedLayoutData={selectedLayoutData}
                  selectedProfileData={selectedProfileData}
                  openendLabel={(data) => sliceImagesList(data)}
                  selectProfile={(data) => setSelectedProfileData(data)} // needs to update via message
                  selectLayout={(data) => setSelectedLayoutData(data)}
                  setHobSpotLabel={setHobSpotLabel}
                  setSelectedHubSpot={setSelectedHubSpot}
                  selectedHubSpot={selectedHubSpot}
                  loading={outerLoader || isLoading || progressiveLoading}
                  setZoom={setZoom}
                />
              )}
            </div>
          </Col>
        ) : null}
      </Row>
    );
  };

  const getYourTheme = () => {
    return getThemeOtherThemes("default");
  };
  // const handleShowImage = () => {
  //   if(!showThumbnail || fullScreen || zoom){
  //     return null
  //   }
  //   const url = showThumbnailImages[showThumbnail?.id] ||  showThumbnail?.thumb
  //   if(!url) return 
  //   return (
  //     <div className="show-image">
  //       <span className="close-icon" onClick={()=> setShowThumbnail(null)}>
  //         <Close />
  //       </span>
  //       <img
  //         src={url}
  //         alt="thumbnail"
  //       />
  //     </div>
  //   );
  // };

  return (
    <>
      <div className={`config-viewer bg-white w-100 h-100`}>
        {getYourTheme()}
        <FullScreen
          onChange={(state) => {
            setFullScreen(state);
          }}
          handle={handle}
        >
          {fullScreen && isImageViewer && (
            <>{getLeftSideContentImageConf(true)}</>
          )}
          {fullScreen && !isImageViewer && (
            <>{getLeftSideContent360Conf(true)}</>
          )}
        </FullScreen>
      </div>
      {(outerLoader || !imageDimensions) && (
        <AnimatedLoader
          hideLoadingText={loadingMessage ? false : true}
          loadingText={loadingMessage}
          zIndex={1000}
          position="fixed"
          top={0}
          backDrop={"rgba(255, 255, 255, 1"}
        />
      )}
    </>
  );
};

export default ImageViewer;
